import { Organization } from './../../core/model/organization';
import { MemberCheck } from './../../core/model/memberCheck';
import { HelperService } from 'src/app/core/service/helper.service';
import { UntypedFormBuilder, Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { Dictionary, Code } from 'src/app/core/model/dictionary';
import moment from 'moment';
import { SettingService } from 'src/app/core/service/setting.service';
import { cloneDeep, reject, sortBy } from 'lodash';
import { ProviderService } from 'src/app/core/service/provider.service';
import { MemberService } from 'src/app/core/service/member.service';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { UserService } from 'src/app/core/service/user.service';
import { User } from 'src/app/user/model/user';
import { TeamService } from 'src/app/core/service/team.service';
import { MessageSubject, MessengerService } from 'src/app/core/service/messenger.service';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ChannelService } from 'src/app/core/service/channel.service';
import { Channel } from 'src/app/channel/model/channel';
import { SelectEvent, TabStripComponent } from '@progress/kendo-angular-layout';
import { AddressValidatorComponent } from '../address-validator/address-validator.component';
import { Team, TeamEdit } from 'src/app/team/model/team';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { OrganizationService } from './../../core/service/organization.service';
import { HelperUtils } from 'src/app/core/utility/helper-utils';
import { TranslateService } from '@ngx-translate/core';
import { InsurerService } from 'src/app/core/service/insurer.service';
import { Insurer } from 'src/app/member/model/member';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { DocumentComponent } from 'src/app/document/document.component';
import { ExtensionService } from 'src/app/core/service/extension.service';
import { GridEventHandler } from 'src/app/core/model/grid-settings';
import { Guid } from 'guid-typescript';
import { forkJoin } from 'rxjs';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { IntlService } from '@progress/kendo-angular-intl';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { OrganizationEdit } from 'src/app/organization/model/organizationEdit';
import { ConsentService } from 'src/app/core/service/consent.service';

@Component({
  standalone: false,
  selector: 'app-patient-edit',
  templateUrl: './patient-edit.component.html',
  styleUrls: ['./patient-edit.component.scss']
})
export class PatientEditComponent implements OnInit
{
  @ViewChild('addressValidator') public addressValidator: AddressValidatorComponent;
  @ViewChild('addressesCollapsible') public addressesCollapsible: any;
  @ViewChild('insurancesCollapsible') public insurancesCollapsible: any;
  @ViewChild('fileInput') public fileInput: any;
  @ViewChild('documentComponent') public documentComponent: DocumentComponent;
  @ViewChild('tabstrip') public tabstrip: TabStripComponent;
  @ViewChild('householdSizeControl') public householdSizeControl: NumericTextBoxComponent;
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  @Input() public isReadOnly = false;
  @Input() public isNew: boolean;
  @Input() public member: any;
  @Input() public channelId: number;
  @Input() public openPatientConsentTab = false;

  @Output() public saved = new EventEmitter<number>();
  @Output() public applied = new EventEmitter<number>();

  public memberForm: any;
  public states: Code[] = [];
  public countries: Code[] = [];
  public genders: Code[] = [];
  public addressTypes: Code[] = [];
  public educationLevels: Code[] = [];
  public employmentStatuses: Code[] = [];
  public maritalStatuses: Code[] = [];
  public religiousAffiliations: Code[] = [];
  public videoProviders: any[] = [];
  public contactMethods: any[] = [];
  public housingStatuses: Code[] = [];
  public veteranStatuses: Code[] = [];
  public minDOB: Date = moment().subtract('120', 'year').toDate();
  public maxDOB: Date = moment().toDate();
  public maxInsuranceDate: Date = new Date(2099, 11, 30, 23, 59, 59, 999);
  public patientLabel = {};
  public patientLabelString: string;
  public types: any[] = [];
  public sources: any[] = [];
  public clonedMember: any = null;
  public caseManagers: User[] = [];
  public languages: Array<{ text: string; value: string }>;
  public notifications: Array<{ text: string; value: string }> = [];
  public addressChanged: boolean[] = [];
  public cellPhoneMandatory = false;
  public emailMandatory = false;
  public viewExtensions: GridViewManager;
  public viewExtensionsShowDisplayName = false;
  public viewExtensionsShowAlternateValue = false;
  public selectedChannel: Channel;
  public memberExistsDialogOpened = false;
  public namePronouns: Code[] = [];
  public englishProficiencies: Code[] = [];
  public interpreterNeeds: Code[] = [];
  public sexualOrientations: Code[] = [];
  public addressAPIEnabled = false;
  public povertyAPIEnabled = false;
  public saving = false;
  public pendingConsents = [];
  public deletedConsents = [];
  public patientContactTeams: string;
  public viewOtherContacts: GridViewManager;
  public editDataItemTeamNonUser: TeamEdit;
  public allowTribalPerUserOrganization = false;
  public showTribalAffiliations = false;
  public showTribalEnrollments = false;
  public showDependents = false;
  public insurancesEnabled = false;
  public addEditInsurancesEnabled = false;
  public loading = true;
  public otherContactsText: string;
  public totalChildrenCodeSet = [];
  public totalAdultsCodeSet = [];
  public totalChildren = 0;
  public totalAdults = 0;
  public patientDemographicsEnableFax = false;
  public patientDemographicsEnablePager = false;
  public patientDemographicsEnableWebsite = false;
  public nameTypes: any[] = [];
  public isHeadOfHousehold = false;
  public tabCounts: any;
  public patientExtensionsEditable = false;
  public showGender = false;
  public showAdministrativeGender = false;
  public patientRestrictionsEnabled = false;
  public authorizedOrganizationsEditable = false;
  public addEditSubjectIdentifiersEnabled = false;

  /**
   * Filtered list of organizations for drop-down.
   */
  public organizationsFiltered: OrganizationEdit[] = [];
  public virtualOrganization: any = { itemHeight: 30 };

  /**
   * Phone number input format mask
   */
  public phoneNumberMask: string;

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  /**
   * Filtered list for drop-down.
   */
  public tribalAffiliationsFiltered: Dictionary[] = [];
  public tribalEnrollmentsFiltered: Dictionary[] = [];
  public spokenLanguagesFiltered: Dictionary[] = [];
  public racesFiltered: Dictionary[] = [];
  public raceEthnicitiesFiltered: Dictionary[] = [];
  public enhancedServicesFiltered: Dictionary[] = [];
  public writtenLanguagesFiltered: Dictionary[] = [];
  public readingLanguagesFiltered: Dictionary[] = [];

  /**
   * All codes
   */
  public allTribalAffiliations = [];
  public allTribalEnrollments = [];
  public allSpokenLanguages = [];
  public allRaces = [];
  public allRaceEthnicities = [];
  public allEnhancedServices = [];
  public allWrittenLanguages = [];
  public allReadingLanguages = [];
  public channelsTypeText = '';
  public channelsSourceText = '';

  /**
   * Maximum number of items for virtualization. This is to accelerate the DOM performance.
   */
  public virtualTribalAffiliation: any = { itemHeight: 30 };
  public virtualTribalEnrollment: any = { itemHeight: 30 };
  public virtualSpokenLanguage: any = { itemHeight: 30 };
  public virtualWrittenLanguage: any = { itemHeight: 30 };
  public virtualReadingLanguage: any = { itemHeight: 30 };
  public virtualEnhancedService: any = { itemHeight: 30 };
  public virtualRace: any = { itemHeight: 30 };
  public virtualRaceEthnicity: any = { itemHeight: 30 };
  public addressesCollapsed = false;

  public insurancesCollapsed = false;
  public insurers: any;
  public insurersFiltered: any;
  public defaultInsurerItem: Insurer = null;
  public currentDefaultInsuredItem: Insurer = null;
  public invalidFileExtensionText: string;
  public dateRangeError: string;
  public insuranceMissing: string;
  public selectedCardFile: any[] = [];
  public isNewFileSelected: boolean[] = [];
  public isFileDeleted: boolean[] = [];
  public urlPattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
  public isOperatorRole = false;
  public applyAction = false;

  public patExtensionFormGroup: any = null;
  public currentUserOrganization: Organization;
  public organizations = [];
  public restrictedOrganizations = [];
  public extensionOrganizations = [];
  public extensionsByCategory = [];
  public extensionsByCategoryAndOrganization = [];
  public extensionsByCategoryAndOrganizationUnused = [];

  public firstOrLastNameRequired = false;
  public insuranceDatesOverlap: string;
  public insuranceDatesOverlapTwoInsurers: string;
  public inValueChanges = false;

  // File restrictions
  public fileRestrictions: FileRestrictions =
    {
      allowedExtensions: ['.jpg', '.jpe', '.jpeg', '.bmp', '.png', '.pdf'],
      maxFileSize: 2000
    };

  private memberToSave: any;
  private requiredDemographics = [];
  private recommendedDemographics = [];
  private demographics: Array<{ text: string; value: string; key: string }>;
  private requiredInsuranceFields = [];
  private insuranceFields: Array<{ text: string; value: string; key: string }>;

  constructor(
    private consentService: ConsentService,
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService,
    private memberService: MemberService,
    private messageHandlerService: MessageHandlerService,
    private settingService: SettingService,
    private providerService: ProviderService,
    private fb: UntypedFormBuilder,
    private helperService: HelperService,
    private dictionaryService: DictionaryService,
    private userService: UserService,
    private messengerService: MessengerService,
    private teamService: TeamService,
    private channelService: ChannelService,
    private authenticationService: AuthenticationService,
    private organizationService: OrganizationService,
    private insurerService: InsurerService,
    private extensionService: ExtensionService,
    public intl: IntlService)
  {
    this.viewExtensions = new GridViewManager(99999);
    this.viewExtensions.setData([]);

    this.viewOtherContacts = new GridViewManager(99999);
    this.viewOtherContacts.setData([]);

    this.translate.get(['CHANNELS', 'CHANNELS-RECORD-NUMBER']).subscribe({
      next: (res) =>
      {
        this.channelsSourceText = res.CHANNELS;
        this.channelsTypeText = res['CHANNELS-RECORD-NUMBER'];
      }
    });
  }

  public get isReadOnlyInsurances(): boolean
  {
    return this.isReadOnly || !this.addEditInsurancesEnabled;
  }

  public get preferredName(): UntypedFormControl
  {
    return this.memberForm.get('preferredName');
  }

  public get firstName(): UntypedFormControl
  {
    return this.memberForm.get('firstName');
  }

  public get lastName(): UntypedFormControl
  {
    return this.memberForm.get('lastName');
  }

  public get middleName(): UntypedFormControl
  {
    return this.memberForm.get('middleName');
  }

  public get dateOfBirth(): UntypedFormControl
  {
    return this.memberForm.get('dateOfBirth');
  }

  public get gender(): UntypedFormControl
  {
    return this.memberForm.get('gender');
  }

  public get administrativeGender(): UntypedFormControl
  {
    return this.memberForm.get('administrativeGender');
  }

  public get raceEthnicities(): UntypedFormControl
  {
    return this.memberForm.get('raceEthnicities');
  }

  public get educationLevel(): UntypedFormControl
  {
    return this.memberForm.get('educationLevel');
  }

  public get employmentStatus(): UntypedFormControl
  {
    return this.memberForm.get('employmentStatus');
  }

  public get maritalStatus(): UntypedFormControl
  {
    return this.memberForm.get('maritalStatus');
  }

  public get religiousAffiliation(): UntypedFormControl
  {
    return this.memberForm.get('religiousAffiliation');
  }

  public get spokenLanguages(): UntypedFormControl
  {
    return this.memberForm.get('spokenLanguages');
  }

  public get writtenLanguages(): UntypedFormControl
  {
    return this.memberForm.get('writtenLanguages');
  }

  public get memberOrganizations(): UntypedFormControl
  {
    return this.memberForm.get('memberOrganizations');
  }

  public get readingLanguages(): UntypedFormControl
  {
    return this.memberForm.get('readingLanguages');
  }

  public get enhancedServices(): UntypedFormControl
  {
    return this.memberForm.get('enhancedServices');
  }

  public get extensions(): UntypedFormControl
  {
    return this.memberForm.get('extensions');
  }

  public get street(): UntypedFormControl
  {
    return this.memberForm.get('street');
  }

  public get streetLineAdditional(): UntypedFormControl
  {
    return this.memberForm.get('streetLineAdditional');
  }

  public get city(): UntypedFormControl
  {
    return this.memberForm.get('city');
  }

  public get county(): UntypedFormControl
  {
    return this.memberForm.get('county');
  }

  public get stateCode(): UntypedFormControl
  {
    return this.memberForm.get('stateCode');
  }

  public get postalCode(): UntypedFormControl
  {
    return this.memberForm.get('postalCode');
  }

  public get countryCode(): UntypedFormControl
  {
    return this.memberForm.get('countryCode');
  }

  public get addressTypeCode(): UntypedFormControl
  {
    return this.memberForm.get('addressTypeCode');
  }

  public get longitude(): UntypedFormControl
  {
    return this.memberForm.get('longitude');
  }

  public get latitude(): UntypedFormControl
  {
    return this.memberForm.get('latitude');
  }

  public get email(): UntypedFormControl
  {
    return this.memberForm.get('email');
  }

  public get preferredVideoProvider(): UntypedFormControl
  {
    return this.memberForm.get('preferredVideoProvider');
  }

  public get homePhone(): UntypedFormControl
  {
    return this.memberForm.get('homePhone');
  }

  public get homePhoneSafe(): UntypedFormControl
  {
    return this.memberForm.get('homePhoneSafe');
  }

  public get workPhoneNumber(): UntypedFormControl
  {
    return this.memberForm.get('workPhoneNumber');
  }

  public get workPhoneNumberExtension(): UntypedFormControl
  {
    return this.memberForm.get('workPhoneNumberExtension');
  }

  public get workPhoneSafe(): UntypedFormControl
  {
    return this.memberForm.get('workPhoneSafe');
  }

  public get otherPhoneNumber(): UntypedFormControl
  {
    return this.memberForm.get('otherPhoneNumber');
  }

  public get otherPhoneSafe(): UntypedFormControl
  {
    return this.memberForm.get('otherPhoneSafe');
  }

  public get cellPhone(): UntypedFormControl
  {
    return this.memberForm.get('cellPhone');
  }

  public get cellPhoneSafe(): UntypedFormControl
  {
    return this.memberForm.get('cellPhoneSafe');
  }

  public get pagerNumber(): UntypedFormControl
  {
    return this.memberForm.get('pagerNumber');
  }

  public get pagerSafe(): UntypedFormControl
  {
    return this.memberForm.get('pagerSafe');
  }

  public get faxNumber(): UntypedFormControl
  {
    return this.memberForm.get('faxNumber');
  }

  public get faxSafe(): UntypedFormControl
  {
    return this.memberForm.get('faxSafe');
  }

  public get url(): UntypedFormControl
  {
    return this.memberForm.get('url');
  }

  public get veteranStatus(): UntypedFormControl
  {
    return this.memberForm.get('veteranStatus');
  }

  public get housingStatus(): UntypedFormControl
  {
    return this.memberForm.get('housingStatus');
  }

  public get householdSize(): UntypedFormControl
  {
    return this.memberForm.get('householdSize');
  }

  public get dependents(): UntypedFormControl
  {
    return this.memberForm.get('dependents');
  }

  public get optOutDate(): UntypedFormControl
  {
    return this.memberForm.get('optOutDate');
  }

  public get optOutReason(): UntypedFormControl
  {
    return this.memberForm.get('optOutReason');
  }

  public get preferredContactMethods(): UntypedFormControl
  {
    return this.memberForm.get('preferredContactMethods');
  }

  public get familyIncome(): UntypedFormControl
  {
    return this.memberForm.get('familyIncome');
  }

  public get familyIncomeUnknownDeclined(): UntypedFormControl
  {
    return this.memberForm.get('familyIncomeUnknownDeclined');
  }

  public get povertyLevel(): UntypedFormControl
  {
    return this.memberForm.get('povertyLevel');
  }

  public get povertyLastModifiedOn(): UntypedFormControl
  {
    return this.memberForm.get('povertyLastModifiedOn');
  }

  public get identifiers(): UntypedFormControl
  {
    return this.memberForm.get('identifiers');
  }

  public get addresses(): UntypedFormControl
  {
    return this.memberForm.get('addresses');
  }

  public get insurances(): UntypedFormControl
  {
    return this.memberForm.get('insurances');
  }

  public get memberChildren(): UntypedFormControl
  {
    return this.memberForm.get('memberChildren');
  }

  public get memberAdults(): UntypedFormControl
  {
    return this.memberForm.get('memberAdults');
  }

  public get channel(): UntypedFormControl
  {
    return this.memberForm.get('channel');
  }

  public get manager(): UntypedFormControl
  {
    return this.memberForm.get('manager');
  }

  public get preferredLanguage(): UntypedFormControl
  {
    return this.memberForm.get('preferredLanguage');
  }

  public get notificationType(): UntypedFormControl
  {
    return this.memberForm.get('notificationType');
  }

  public get namePronoun(): UntypedFormControl
  {
    return this.memberForm.get('namePronoun');
  }

  public get namePronounOther(): UntypedFormControl
  {
    return this.memberForm.get('namePronounOther');
  }

  public get englishProficiency(): UntypedFormControl
  {
    return this.memberForm.get('englishProficiency');
  }

  public get interpreterNeed(): UntypedFormControl
  {
    return this.memberForm.get('interpreterNeed');
  }

  public get interpreterNeedOther(): UntypedFormControl
  {
    return this.memberForm.get('interpreterNeedOther');
  }

  public get livesAlone(): UntypedFormControl
  {
    return this.memberForm.get('livesAlone');
  }

  public get primaryCaregiver(): UntypedFormControl
  {
    return this.memberForm.get('primaryCaregiver');
  }

  public get races(): UntypedFormControl
  {
    return this.memberForm.get('races');
  }

  public get sexualOrientation(): UntypedFormControl
  {
    return this.memberForm.get('sexualOrientation');
  }

  public get tribalAffiliated(): UntypedFormControl
  {
    return this.memberForm.get('tribalAffiliated');
  }

  public get tribalAffiliations(): UntypedFormControl
  {
    return this.memberForm.get('tribalAffiliations');
  }

  public get tribalEnrolled(): UntypedFormControl
  {
    return this.memberForm.get('tribalEnrolled');
  }

  public get tribalEnrollments(): UntypedFormControl
  {
    return this.memberForm.get('tribalEnrollments');
  }

  public get otherNames(): UntypedFormControl
  {
    return this.memberForm.get('otherNames');
  }

  public getOptOutDateTitle(optOutDate: string, optOutReason: string): string
  {
    return this.consentService.getOptOutDateTitle(optOutDate, optOutReason);
  }

  /**
   * Check if the demographic is required.
   *
   * @param demographic Demographic value to check.
   * @returns True if the demographic is required.
   */
  public isRequired(demographic: string): boolean
  {
    if ((demographic === 'FAX' && !this.patientDemographicsEnableFax) ||
      (demographic === 'PAGER' && !this.patientDemographicsEnablePager) ||
      (demographic === 'URL' && !this.patientDemographicsEnableWebsite))
    {
      return false;
    }
    else
    {
      return this.requiredDemographics.indexOf(demographic) !== -1;
    }
  }

  public isRecommended(demographic: string): boolean
  {
    if ((demographic === 'FAX' && !this.patientDemographicsEnableFax) ||
      (demographic === 'PAGER' && !this.patientDemographicsEnablePager) ||
      (demographic === 'URL' && !this.patientDemographicsEnableWebsite))
    {
      return false;
    }
    else
    {
      return this.recommendedDemographics.indexOf(demographic) !== -1;
    }
  }

  public memberAdultsTrackBy(index: number, item: any): string
  {
    return item.adultId?.value;
  }

  public memberChildrenTrackBy(index: number, item: any): string
  {
    return item.childrenId?.value;
  }

  /**
   * This is conditionaly show the *
   */
  public requiredLabel(demographic: string): string
  {
    switch (demographic)
    {
      case 'EMAIL':
        return this.emailMandatory || this.isRequired(demographic) ? '*' : '';
      case 'CELL_PHONE':
        return this.cellPhoneMandatory || this.isRequired(demographic) ? '*' : '';
      case 'ADDRESS_TYPE':
        return '*';
      default:
        return this.isRequired(demographic) ? '*' : '';
    }
  }

  public requiredText(demographic: string): string
  {
    const foundDemographic = this.demographics.find(x => x.value === demographic);
    if (foundDemographic)
    {
      return foundDemographic.text;
    }
    else
    {
      return demographic;
    }
  }

  public isRequiredInsurance(insuranceField: string): boolean
  {
    return this.requiredInsuranceFields.indexOf(insuranceField) !== -1;
  }

  public requiredLabelInsurance(insuranceField: string): string
  {
    return this.isRequiredInsurance(insuranceField) ? '*' : '';
  }

  public requiredTextInsurance(insuranceField: string): string
  {
    const foundInsuranceField = this.insuranceFields.find(x => x.value === insuranceField);
    if (foundInsuranceField)
    {
      return foundInsuranceField.text;
    }
    else
    {
      return insuranceField;
    }
  }

  public ngOnInit(): void
  {
    this.loading = true;
    this.isOperatorRole = this.authenticationService.currentUser.role === 'ROLE_OPERATOR';
    this.extensionService.getDistinctExtensionOrganizations('PATIENT').subscribe({
      next: (data) =>
      {
        this.extensionOrganizations = data;
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });

    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.povertyAPIEnabled = sessionSetting.povertyAPIEnabled;
        this.phoneNumberMask = sessionSetting.phoneMask;
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
        this.patientLabelString = sessionSetting.patientLabel;
        this.requiredDemographics = sessionSetting.requiredDemographics ? sessionSetting.requiredDemographics.split(',') : [];
        this.recommendedDemographics = sessionSetting.recommendedDemographics ? sessionSetting.recommendedDemographics.split(',') : [];
        this.demographics = this.memberService.demographics;
        this.requiredInsuranceFields = sessionSetting.requiredInsuranceFields ? sessionSetting.requiredInsuranceFields.split(',') : [];
        this.insuranceFields = this.memberService.insuranceFields;
        this.languages = this.userService.preferredLanguages;
        this.notifications = this.teamService.notifications;
        this.addressAPIEnabled = sessionSetting.addressAPIEnabled;
        this.patientContactTeams = sessionSetting.patientContactTeams;
        this.showTribalAffiliations = sessionSetting.showTribalAffiliations;
        this.showTribalEnrollments = sessionSetting.showTribalEnrollments;
        this.showDependents = sessionSetting.showDependents;
        this.insurancesEnabled = (sessionSetting.insurancesRoles !== '') ?
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.insurancesRoles) : false;
        this.addEditInsurancesEnabled = (sessionSetting.addUpdateInsurancesRoles !== '') ?
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.addUpdateInsurancesRoles) : false;
        this.addEditSubjectIdentifiersEnabled = (sessionSetting.updateSubjectIdentifiersRoles !== '') ?
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.updateSubjectIdentifiersRoles) : false;
        this.patientDemographicsEnableFax = sessionSetting.patientDemographicsEnableFax;
        this.patientDemographicsEnablePager = sessionSetting.patientDemographicsEnablePager;
        this.patientDemographicsEnableWebsite = sessionSetting.patientDemographicsEnableWebsite;
        this.patientExtensionsEditable = (sessionSetting.addUpdateExtensionsRoles !== '') ?
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.addUpdateExtensionsRoles) : false;
        this.authorizedOrganizationsEditable = (sessionSetting.addUpdateAuthorizedOrganizationsRoles !== '') ?
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.addUpdateAuthorizedOrganizationsRoles) : false;
        this.showGender = sessionSetting.showGender;
        this.showAdministrativeGender = sessionSetting.showAdministrativeGender;
        this.patientRestrictionsEnabled = sessionSetting.patientRestrictionsEnabled;

        // Loading all dictionaries
        forkJoin([
          this.helperService.getGendersStatesCountriesAddressTypesFromMultipleSources(),
          this.helperService.getDemographicsDictionariesFromMultipleSources(),
          this.dictionaryService.getCachedTribalAffiliations(),
          this.dictionaryService.getCachedTribalEnrollments(),
          this.dictionaryService.getCachedLanguages(),
          this.dictionaryService.getCachedEnhancedServices(),
          this.dictionaryService.getCachedRaces(),
          this.dictionaryService.getCachedRaceEthnicities(),
          this.providerService.getVideoProviders(),
          this.dictionaryService.getCachedIdentifiers(),
          this.dictionaryService.getCachedIdentifierSources(),
          this.dictionaryService.getCachedNameTypes(),
          this.organizationService.getCachedOrganizations()
        ])
          .subscribe((responseList: any) =>
          {
            this.genders = responseList[0][0];
            this.states = responseList[0][1];
            this.countries = responseList[0][2];
            this.addressTypes = responseList[0][3];

            this.educationLevels = responseList[1][0];
            this.employmentStatuses = responseList[1][1];
            this.maritalStatuses = responseList[1][2];
            this.religiousAffiliations = responseList[1][3];
            this.housingStatuses = responseList[1][4];
            this.veteranStatuses = responseList[1][5];
            this.namePronouns = responseList[1][6];
            this.englishProficiencies = responseList[1][7];
            this.interpreterNeeds = responseList[1][8];
            this.sexualOrientations = responseList[1][9];

            this.allTribalAffiliations = responseList[2];
            this.filterTribalAffiliations('');

            this.allTribalEnrollments = responseList[3];
            this.filterTribalEnrollments('');

            this.allSpokenLanguages = responseList[4];
            this.filterSpokenLanguages('');

            this.allWrittenLanguages = responseList[4];
            this.filterWrittenLanguages('');

            this.allReadingLanguages = responseList[4];
            this.filterReadingLanguages('');

            this.allEnhancedServices = responseList[5];
            this.filterEnhancedServices('');

            this.allRaces = responseList[6];
            this.filterRaces('');

            this.allRaceEthnicities = responseList[7];
            this.filterRaceEthnicities('');

            this.videoProviders = sortBy(responseList[8], ['name']);

            this.types = responseList[9];

            this.sources = responseList[10];

            this.nameTypes = responseList[11];

            this.organizations = sortBy(responseList[12], ['name']);
            this.restrictedOrganizations = cloneDeep(this.organizations);
            this.filterRestrictedOrganizations('');

            if (!this.patientDemographicsEnablePager)
            {
              this.contactMethods = this.memberService.preferredContactMethods.filter(x => x.value !== 'PAGER');
            }
            else
            {
              this.contactMethods = this.memberService.preferredContactMethods;
            }

            // Refresh member before edit
            if (!this.isNew)
            {
              this.memberService.getMember(this.member.id).subscribe({
                next: (member) =>
                {
                  this.continueMemberLoad(member);
                },
                error: (errorResponse) =>
                {
                  this.messageHandlerService.displayError(errorResponse);
                }
              });
            }
            else
            {
              this.continueMemberLoad(this.member);
            }
          });
      }
    });

    // Get user organization
    const user = this.authenticationService.currentUser;
    this.userService.getUserById(user.id, false).subscribe({
      next: (data) =>
      {
        this.currentUserOrganization = data.organization;
        // Get Allow Tribal for user organization
        this.organizationService.getOrganizationById(data.organization.id).subscribe({
          next: (organizationData) =>
          {
            this.allowTribalPerUserOrganization = organizationData.allowTribal;
          },
          error: (errorResponse) =>
          {
            this.messageHandlerService.displayError(errorResponse);
          }
        });
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });

    if ((this.getRequiredValidator('FIRST_NAME_OTHER_NAMES') === null) && (this.getRequiredValidator('LAST_NAME_OTHER_NAMES') === null))
    {
      this.firstOrLastNameRequired = true;
    }

    this.tabCounts = null;
    if (!this.isNew && this.insurancesEnabled)
    {
      this.getMemberCountTabs();
    }
  }

  public save(): void
  {
    this.onSubmit();
  }

  public formValid(): boolean
  {
    if (this.memberForm === undefined)
    {
      return false;
    }
    else
    {
      return this.memberForm.valid;
    }
  }

  public formDirty(): boolean
  {
    return this.memberForm.dirty;
  }

  public formSaving(): boolean
  {
    return this.saving || this.applyAction;
  }

  public addIdentifier(id: number = null, version = 0, type: any = null, source: any = null,
    identifierValue: string = null, isLoading = false): void
  {
    this.memberForm.controls.identifiers.push(this.initIdentifier(id, version, type, source, identifierValue));
    if (!isLoading)
    {
      this.memberForm.markAsDirty();
    }
  }

  public addOtherName(id: number = null, version = 0, nameType: any = null,
    givenName: string = null, familyName: string = null, isLoading = false): void
  {
    this.memberForm.controls.otherNames.push(this.initOtherName(id, version, nameType, givenName, familyName));
    if (!isLoading)
    {
      this.memberForm.markAsDirty();
    }
  }

  public primaryAddressClicked(index: number): void
  {
    for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
    {
      // Automatically trigger reset of other addresses entry when primary is changed
      if (i !== index)
      {
        this.memberForm.controls.addresses.controls[i].get('isPrimary').patchValue(false, { emitEvent: false });
      }
    }
  }

  public addAddress(id: number = null, addressTypeCode: any = null, isPrimary = false,
    streetLine: string = null, streetLineAdditional: string = null, city: string = null, county: string = null,
    stateCode: any = null, postalCode: string = null, countryCode: any = null,
    latitude: string = null, longitude: string = null,
    isLoading = false, setCountry = true): void
  {
    this.memberForm.controls.addresses.push(this.initAddress(id, addressTypeCode, isPrimary, streetLine, streetLineAdditional, city, county,
      stateCode, postalCode, countryCode, latitude, longitude));

    // New Address button clicked
    if (id === null && addressTypeCode === null && isPrimary === false && streetLine === null && streetLineAdditional === null &&
      city === null && county === null && stateCode === null && postalCode === null && countryCode === null &&
      latitude === null && longitude === null && isLoading === false && setCountry === true)
    {
      this.addressChanged[this.memberForm.controls.addresses.controls.length - 1] = true;
    }

    if (!isLoading)
    {
      if (this.addressesCollapsible)
      {
        this.addressesCollapsible.toggleChange(false);
      }
      this.memberForm.markAsDirty();
    }

    // Automatically set the country on add if only one available (one click less)
    if (setCountry && this.countries.length === 1)
    {
      for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
      {
        if (this.memberForm.controls.addresses.controls[i].controls.country.value === null ||
          this.memberForm.controls.addresses.controls[i].controls.country.value === undefined)
        {
          this.memberForm.controls.addresses.controls[i].controls.country.value = this.countries[0];
        }
      }
    }
  }

  public removeIdentifier(i: number, id: number): void
  {
    const control = this.memberForm.controls.identifiers;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.clonedMember.identifiers = reject(this.clonedMember.identifiers, rejectedId);
    }
    control.removeAt(i);
    this.memberForm.touched = true;
    this.memberForm.markAsDirty();
  }

  public removeOtherName(i: number, id: number): void
  {
    const control = this.memberForm.controls.otherNames;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.clonedMember.otherNames = reject(this.clonedMember.otherNames, rejectedId);
    }
    control.removeAt(i);
    this.memberForm.touched = true;
    this.memberForm.markAsDirty();
  }

  public removeAddress(i: number, id: number): void
  {
    const control = this.memberForm.controls.addresses;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.clonedMember.addresses = reject(this.clonedMember.addresses, rejectedId);
    }
    control.removeAt(i);
    this.memberForm.touched = true;
    this.memberForm.markAsDirty();
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public patExtensionsDataStateChange(state: DataStateChangeEvent): void
  {
    this.viewExtensions.setState(state);
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public dataStateChangeViewOtherContacts(state: DataStateChangeEvent): void
  {
    this.viewOtherContacts.setState(state);
  }

  /**
   * Event called when the tab is selected.
   *
   * @param event Event object
   */
  public onSelectTab(event: SelectEvent)
  {
    if (!this.isNew && event.title === this.otherContactsText)
    {
      this.viewOtherContacts.startLoading();
      this.userService.getNonUsersByMember(this.clonedMember.id, this.patientContactTeams).subscribe({
        next: (loadedCareTeams) =>
        {
          const data = [];

          // Care Team Users
          loadedCareTeams.forEach(careTeam =>
          {
            data.push({
              id: careTeam.id,
              name: careTeam.firstName || careTeam.lastName ? `${careTeam.firstName} ${careTeam.lastName}` : `${careTeam.organization}`,
              teamRole: careTeam.roleName,
              teamSubRole: careTeam.subRoleName,
              organization: !careTeam.firstName && !careTeam.lastName ? careTeam.organization : '',
              homePhoneNumber: careTeam.homePhoneNumber,
              homePhoneNumberExtension: careTeam.homePhoneNumberExtension,
              cellPhoneNumber: careTeam.cellPhoneNumber,
              workPhoneNumber: careTeam.workPhoneNumber,
              workPhoneNumberExtension: careTeam.workPhoneNumberExtension,
              otherPhoneNumber: careTeam.otherPhoneNumber,
              email: careTeam.email
            });
          });
          this.viewOtherContacts.setData(data);
          this.viewOtherContacts.setSort([{ field: 'name', dir: 'asc' }]);
        },
        error: (error) =>
        {
          this.messageHandlerService.displayError(error);
        },
        complete: () =>
        {
          this.viewOtherContacts.startLoading();
        }
      });
    }
  }

  /**
   * Member already exits, confirm action before inserting a duplicate member.
   *
   * @param confirm Continue with save confirmation.
   */
  public continueSaveAction(confirm: boolean): void
  {
    this.memberExistsDialogOpened = false;
    if (confirm)
    {
      this.performMemberSave(this.memberToSave);
    }
  }

  /**
   * Filters the Tribal Affiliations based on user input.
   */
  public filterTribalAffiliations(filter: string): void
  {
    this.searchTerm = filter;
    this.tribalAffiliationsFiltered = this.allTribalAffiliations
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the Tribal Enrollments based on user input.
   */
  public filterTribalEnrollments(filter: string): void
  {
    this.searchTerm = filter;
    this.tribalEnrollmentsFiltered = this.allTribalEnrollments
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the Spoken Languages based on user input.
   */
  public filterSpokenLanguages(filter: string): void
  {
    this.searchTerm = filter;
    this.spokenLanguagesFiltered = this.allSpokenLanguages
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public filterWrittenLanguages(filter: string): void
  {
    this.searchTerm = filter;
    this.writtenLanguagesFiltered = this.allWrittenLanguages
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public filterReadingLanguages(filter: string): void
  {
    this.searchTerm = filter;
    this.readingLanguagesFiltered = this.allReadingLanguages
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the EnhancedServices based on user input.
   */
  public filterEnhancedServices(filter: string): void
  {
    this.searchTerm = filter;
    this.enhancedServicesFiltered = this.allEnhancedServices
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Add patient extension handler
   *
   * @param event Grid Event Handler
   */
  public patExtensionAddHandler(event: GridEventHandler): void
  {
    // Get the default organization
    let defaultOrganization: Organization;
    if (this.currentUserOrganization !== undefined)
    {
      defaultOrganization = this.organizations.find(x => x.id === this.currentUserOrganization.id);
    }

    this.patExtensionFormGroup = this.formBuilder.group(
      {
        isNew: true,
        id: Guid.create().toString(),
        organization: [{
          value: defaultOrganization,
          disabled: false
        }, Validators.required],
        settingExtension: [{ value: null, disabled: false }, Validators.required],
        value: [{ value: null, disabled: false }, Validators.required],
        codeSetId: null,
        editing: true
      }
    );

    event.sender.addRow(this.patExtensionFormGroup);

    if (defaultOrganization !== undefined)
    {
      this.organizationChange(false);
    }
  }

  /**
   * Handles the edit event of the patient extensions grid.
   */
  public patExtensionEditHandler(event: GridEventHandler): void
  {
    this.patExtensionFormGroup = this.formBuilder.group(
      {
        isNew: false,
        id: event.dataItem.id,
        organization: [event.dataItem.settingExtension.organization, Validators.required],
        value: [event.dataItem.value, Validators.required],
        settingExtension: [event.dataItem.settingExtension, Validators.required],
        codeSetId: event.dataItem.codeSetId,
        editing: true,
      }
    );
    this.organizationChange(false);
    this.patExtensionFormGroup.get('value').valueChanges.subscribe({ next: (value: string) => { this.refreshExtensionDisplayNames(value); } });
    event.sender.editRow(event.rowIndex, this.patExtensionFormGroup);
  }

  /**
   * Extension save action.
   *
   * @param event Current record
   */
  public patExtensionSaveHandler(event: GridEventHandler): void
  {
    this.patExtensionFormGroup.get('editing').setValue(false);

    // Construct data
    const data: any = {};
    data.id = this.patExtensionFormGroup.get('id').value;
    data.settingExtension =
      this.extensionsByCategoryAndOrganization.find(x => x.id === this.patExtensionFormGroup.get('settingExtension').value.id);
    data.value = this.patExtensionFormGroup.get('value').value;
    data.memberId = this.member ? this.member.id : null;
    data.organizationId = this.patExtensionFormGroup.get('organization').value.id;
    data.settingExtension.organization = this.patExtensionFormGroup.get('organization').value;
    data.codeSetId = this.patExtensionFormGroup.get('codeSetId').value;
    data.displayName = event.dataItem?.displayName || null;
    data.alternateValue = event.dataItem?.alternateValue || null;
    data.lastModifiedOn = event.dataItem?.lastModifiedOn
      ? new Date(event.dataItem.lastModifiedOn)
      : new Date();

    if (this.patExtensionFormGroup.get('isNew').value) 
    {
      this.extensions.value.push(data);
    }
    else
    {
      const currentRowIndex = this.extensions.value.findIndex(x => x.id === data.id);
      if (currentRowIndex >= 0)
      {
        this.extensions.value[currentRowIndex] = data;
      }
    }

    this.viewExtensions.setData(this.extensions.value);

    event.sender.closeRow(event.rowIndex);

    this.extensions.markAsDirty();
    this.memberForm.markAsDirty();
  }

  /**
   * Cancelling the patient extension add action.
   *
   * @param event Current row
   */
  public patExtensionCancelHandler(event: GridEventHandler): void
  {
    this.refreshExtensionDisplayNames(event.dataItem.value);
    event.sender.closeRow(event.rowIndex);
  }

  /**
   * Delete entered patient extension from grid.
   *
   * @param extension Patient Extension record to remove.
   */
  public deletePatExtension(extension: any): void
  {
    this.extensions.setValue(this.extensions.value.filter(c => c.id !== extension.id));
    this.viewExtensions.setData(this.extensions.value);
    this.setViewExtensionsColumnsVisibility();
    this.memberForm.markAsDirty();
  }

  /**
   * Extension organization changed.
   */
  public organizationChange(reset: boolean): void
  {
    if (reset)
    {
      this.extensionsByCategory = [];
      this.extensionsByCategoryAndOrganization = [];
      this.extensionsByCategoryAndOrganizationUnused = [];
      this.patExtensionFormGroup.get('settingExtension').setValue(null);
    }
    if (this.patExtensionFormGroup.get('organization').value)
    {
      this.extensionService.getExtensionsByCategory('PATIENT').subscribe({
        next: (data) =>
        {
          this.extensionsByCategory = data;
          this.extensionsByCategoryAndOrganization = this.extensionsByCategory.filter(
            extension => extension.organization === null || extension.organization.id === this.patExtensionFormGroup.get('organization').value.id);
          const extensionsInUse = this.viewExtensions.gridData.data.filter(
            extension => extension.id !== (this.patExtensionFormGroup.get('organization').value ? this.patExtensionFormGroup.get('organization').value.id : null));
          this.extensionsByCategoryAndOrganizationUnused = sortBy(
            this.extensionsByCategoryAndOrganization.filter(u => !extensionsInUse.map(m => m.settingExtension.id).includes(u.id)), ['name']);
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
    }
  }

  /**
   * Address change event from Address Validator component.
   *
   * @param event Address data being selected to apply.
   */
  public changeAddress(event: any): void
  {
    // Override the address based on Address API response.
    const i = event.addressIndex;

    if (event.confirmation === 'recommended')
    {
      // Force dirty to change state
      this.memberForm.markAsDirty();

      const newStreetLine = event.line1;
      const newStreetLineAdditional = event.line2;
      const newCity = event.postalAddress && event.postalAddress.locality ? event.postalAddress.locality : null;
      const newStateCode = event.postalAddress && event.postalAddress.administrativeArea ? event.postalAddress.administrativeArea : null;
      const newPostalCode = event.postalAddress && event.postalAddress.postalCode ? event.postalAddress.postalCode : null;
      const newCountryCode = event.postalAddress && event.postalAddress.regionCode ?
        this.countries.find(x => x.alternateCode === event.postalAddress.regionCode)?.code : null;
      const newLatitude = event.geocode && event.geocode.location ? event.geocode.location.latitude : null;
      const newLongitude = event.geocode && event.geocode.location ? event.geocode.location.longitude : null;

      // Set form properties
      if (event.autoSave && this.memberForm.controls.addresses.controls[i].controls.isPrimary.value === true)
      {
        // if this is the Primary then Address (street, etc) should be updated too
        this.street.setValue(newStreetLine);
        this.streetLineAdditional.setValue(newStreetLineAdditional);
        this.city.setValue(newCity);
        this.stateCode.setValue(newStateCode);
        this.postalCode.setValue(newPostalCode);
        this.countryCode.setValue(newCountryCode);
        this.latitude.setValue(newLatitude);
        this.longitude.setValue(newLongitude);

        this.memberToSave.addresses[i].streetLine = newStreetLine;
        this.memberToSave.addresses[i].streetLineAdditional = newStreetLineAdditional;
        this.memberToSave.addresses[i].city = newCity;
        this.memberToSave.addresses[i].stateCode = newStateCode;
        this.memberToSave.addresses[i].postalCode = newPostalCode;
        this.memberToSave.addresses[i].countryCode = newCountryCode;
        this.memberToSave.addresses[i].latitude = newLatitude;
        this.memberToSave.addresses[i].longitude = newLongitude;
      }

      this.memberForm.controls.addresses.controls[i].controls.streetLine.setValue(newStreetLine);
      this.memberForm.controls.addresses.controls[i].controls.streetLineAdditional.setValue(newStreetLineAdditional);
      this.memberForm.controls.addresses.controls[i].controls.city.setValue(newCity);
      this.memberForm.controls.addresses.controls[i].controls.state.setValue(newStateCode ?
        this.states.find(x => x.code === newStateCode) : null);
      this.memberForm.controls.addresses.controls[i].controls.postalCode.setValue(newPostalCode);
      this.memberForm.controls.addresses.controls[i].controls.country.setValue(newCountryCode ?
        this.countries.find(x => x.code === newCountryCode) : null);
      this.memberForm.controls.addresses.controls[i].controls.latitude.setValue(newLatitude);
      this.memberForm.controls.addresses.controls[i].controls.longitude.setValue(newLongitude);

      this.addressChanged[i] = false;
    }
    else
    {
      if (event.autoSave && this.memberForm.controls.addresses.controls[i].controls.isPrimary.value === true)
      {
        // if this is the Primary then Address (latitude, longitude) should be updated too
        this.latitude.setValue(null);
        this.longitude.setValue(null);
      }
      this.memberForm.controls.addresses.controls[i].controls.latitude.setValue(null);
      this.memberForm.controls.addresses.controls[i].controls.longitude.setValue(null);
    }

    // If autoSave, then set patient object and save.
    if (event.autoSave)
    {
      this.memberToSave.streetLine = this.memberForm.controls.addresses.controls[i].controls.streetLine.value; // this.street.value;
      this.memberToSave.streetLineAdditional = this.memberForm.controls.addresses.controls[i].controls.streetLineAdditional.value;
      this.memberToSave.stateCode = this.memberForm.controls.addresses.controls[i].controls.state.value != null ?
        this.memberForm.controls.addresses.controls[i].controls.state.value.code : null;
      this.memberToSave.city = this.memberForm.controls.addresses.controls[i].controls.city.value;
      this.memberToSave.postalCode = this.memberForm.controls.addresses.controls[i].controls.postalCode.value;
      this.memberToSave.countryCode = this.memberForm.controls.addresses.controls[i].controls.country.value != null ?
        this.memberForm.controls.addresses.controls[i].controls.country.value.code : null;
      this.memberToSave.latitude = this.memberForm.controls.addresses.controls[i].controls.latitude.value;
      this.memberToSave.longitude = this.memberForm.controls.addresses.controls[i].controls.longitude.value;

      this.savePatient();
    }
  }

  /**
   * Manual Address Validation. No autoSave will be performed.
   */
  public validateAddress(i: number): void
  {
    this.addressValidator.execute(false,
      this.memberForm.controls.addresses.controls[i].controls.streetLine.value,
      this.memberForm.controls.addresses.controls[i].controls.streetLineAdditional.value,
      this.memberForm.controls.addresses.controls[i].controls.city.value,
      this.memberForm.controls.addresses.controls[i].controls.state.value != null ?
        this.memberForm.controls.addresses.controls[i].controls.state.value.code : null,
      this.memberForm.controls.addresses.controls[i].controls.country.value != null ?
        this.memberForm.controls.addresses.controls[i].controls.country.value.code : null,
      this.memberForm.controls.addresses.controls[i].controls.postalCode.value,
      i);
  }

  /**
   * Perform the Patient Save.
   *
   */
  public savePatient(): void
  {
    // Set pending consents to save if any
    this.pendingConsents.forEach((consent) => delete consent.id);
    this.memberToSave.consents = this.pendingConsents;
    this.memberToSave.consentsDeleted = this.deletedConsents;
    this.memberToSave.preferredLanguage = this.preferredLanguage.value ? this.preferredLanguage.value : null;
    this.memberToSave.preferredContactMethods = this.preferredContactMethods.value ? this.preferredContactMethods.value : null;

    // Must remove temporary guid from extensions
    this.memberToSave.extensions.forEach((e) => { if (!Number.isFinite(e.id)) { e.id = null; } });

    // Set member children and adults
    this.setMemberChildren(this.memberToSave);
    this.setMemberAdults(this.memberToSave);

    // Set written and reading languages
    this.setMemberWrittenLanguages(this.memberToSave);
    this.setMemberReadingLanguages(this.memberToSave);
    this.setMemberOrganizations(this.memberToSave);

    // Save Member
    this.memberService.saveMember(this.memberToSave, this.isNew).subscribe({
      next: (data) =>
      {
        // emitting event so other components can update if needed.
        let patientId: number;
        if (this.channelId !== undefined)
        {
          this.messageHandlerService.displaySuccess('CASE-SAVE-SUCCESS');
          if (this.isNew)
          {
            patientId = data.memberId;
          }
          else
          {
            patientId = data.id;
          }
        }
        else
        {
          this.messageHandlerService.displaySuccess('MEMBER-SAVE-SUCCESS');
          patientId = data.id;
        }
        this.memberService.saveRecentView(patientId).subscribe({
          error: (errorResponse: any) =>
          {
            this.messageHandlerService.displayError(errorResponse);
          }
        });
        this.messengerService.sendMessage(new MessageSubject('patientUpdated', data));
        if (this.applyAction) 
        {
          this.applied.emit(data);
          this.applyAction = false;
          this.isNew = false;
          this.pendingConsents = [];
          this.deletedConsents = [];
          // Refresh member after Apply
          this.memberService.getMember(patientId).subscribe({
            next: (member) =>
            {
              this.member = member;
              this.continueMemberLoad(member, true);
            },
            error: (errorResponse) =>
            {
              this.messageHandlerService.displayError(errorResponse);
            }
          });
        }
        else
        {
          this.saved.emit(data);
          this.saving = false;
        }
        for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
        {
          this.addressChanged[i] = false;
        }
      },
      error: () =>
      {
        if (this.channelId !== undefined)
        {
          this.messageHandlerService.displayError('CASE-SAVE-ERROR');
        }
        else
        {
          this.messageHandlerService.displayError('MEMBER-SAVE-ERROR');
        }
      }
    });
  }

  public apply(): void
  {
    this.applyAction = true;
    this.onSubmit();
  }

  /**
   * Filters the Race Ethnicities based on user input.
   */
  public filterRaceEthnicities(filter: string): void
  {
    this.searchTerm = filter;
    this.raceEthnicitiesFiltered = this.allRaceEthnicities
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the Races based on user input.
   */
  public filterRaces(filter: string): void
  {
    this.searchTerm = filter;
    this.racesFiltered = this.allRaces
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public consentAdded(e: any): void
  {
    this.memberForm.markAsDirty();
    this.pendingConsents = e;
    this.saving = false;
  }

  public consentDeleted(e: any): void
  {
    this.memberForm.markAsDirty();
    this.deletedConsents = e;
    this.saving = false;
  }

  public optInAction(): void
  {
    this.memberForm.markAsDirty();
    this.optOutDate.setValue(null);
    this.optOutReason.setValue(null);
    this.save();
  }

  public optOutAction(optOutData: any): void
  {
    this.memberForm.markAsDirty();
    let optOutDate: string;
    if (optOutData.optOutDate instanceof Date)
    {
      optOutDate = this.intl.formatDate(optOutData.optOutDate, 'd');
    }
    else
    {
      optOutDate = this.intl.formatDate(this.intl.parseDate(optOutData.optOutDate), 'd');
    }
    const optOutReason = optOutData.optOutReason ? optOutData.optOutReason : '';
    const sendOptOut = optOutData.sendOptOut ? optOutData.sendOptOut : false;
    this.optOutDate.setValue(moment(optOutData.optOutDate).format('YYYY-MM-DD').toString());
    this.optOutReason.setValue(optOutReason);
    this.memberService.revokeAllConsents(this.member.id, sendOptOut, optOutDate, optOutReason).subscribe({
      next: () =>
      {
        this.save();
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  /**
   * Get the user and open the dialog of team details
   *
   * @param user User to send at the component
   */
  public editOtherContactsHandler(careTeam: Team): void
  {
    this.messengerService.sendMessage(new MessageSubject('openEditCareTeamMember',
      {
        id: careTeam.id
      }));
  }

  public addInsurance(id: number = null,
    insurer: any = null, startDate: any = null, endDate: any = null,
    insuredGivenName: string = null, insuredFamilyName: string = null, businessPhoneNumber: string = null,
    insuranceMemberId: string = null, plan: string = null, groupId: string = null,
    policyHolder: string = null, employer: string = null, insurerUrl: string = null,
    card: any = null, cardDocumentName: string = null, cardDocumentMimeType: string = null, deleteCard = false,
    cardDocumentId: string = null, cardDocumentDate: any = null, cardDocumentUrl: string = null,
    insuranceExternalId: string = null,
    deleted = false,
    isLoading = false): void
  {
    this.memberForm.controls.insurances.push(this.initInsurance(id,
      insurer, startDate, endDate,
      insuredGivenName, insuredFamilyName, businessPhoneNumber,
      insuranceMemberId, plan, groupId,
      policyHolder, employer, insurerUrl,
      card, cardDocumentName, cardDocumentMimeType, deleteCard,
      cardDocumentId, cardDocumentDate, cardDocumentUrl, insuranceExternalId,
      deleted
    ));

    if (!isLoading)
    {
      if (this.insurancesCollapsible)
      {
        this.insurancesCollapsible.toggleChange(false);
      }
      this.memberForm.markAsDirty();
    }
  }

  public removeInsurance(i: number, id: number): void
  {
    const control = this.memberForm.controls.insurances;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      this.memberForm.controls.insurances.controls[i].controls.deleted.setValue(true);
    }
    else
    {
      control.removeAt(i);
    }
    this.memberForm.touched = true;
    this.memberForm.markAsDirty();
  }

  public insurerItemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  /**
   * Handle Insurer filtering.
   *
   * @param filter Filter entered.
   */
  public handleInsurerFilter(filter: string): void
  {
    this.searchTerm = filter;
    this.insurersFiltered = sortBy(this.insurers
      .filter((s: Insurer) => s.name.toLowerCase().includes(filter.toLowerCase()) && (s.active || !filter)), ['name']);

    // Setting currentDefaultInsuredItem is a workaround to hide the 'Select an insurer...' when insurer not found.
    this.currentDefaultInsuredItem = this.insurersFiltered.length === 0 ? null : this.defaultInsurerItem;
  }

  public openInsurerUrl(i: number): void
  {
    if (this.isValidInsurerUrl(i))
    {
      window.open(this.memberForm.controls.insurances.controls[i].controls.insurerUrl.value);
    }
  }

  public isValidInsurerUrl(i: number): boolean
  {
    const regEx = new RegExp(this.urlPattern);
    return this.memberForm.controls.insurances.controls[i].controls.insurerUrl.value !== undefined &&
      this.memberForm.controls.insurances.controls[i].controls.insurerUrl.value &&
      regEx.test(this.memberForm.controls.insurances.controls[i].controls.insurerUrl.value);
  }

  public isValidUrl(): boolean
  {
    const regEx = new RegExp(this.urlPattern);
    return this.url.value !== undefined && this.url.value && regEx.test(this.url.value);
  }

  public openUrl(): void
  {
    if (this.isValidUrl())
    {
      window.open(this.url.value);
    }
  }

  public getPatientFullName(): string
  {
    if (this.memberForm)
    {
      return `${this.firstName.value} ${this.lastName.value}`
    }
    else
    {
      return '';
    }
  }

  /**
   * File has been selected.
   *
   * @param event Event
   */
  public onFileChanged(event: Event, i: number): void
  {
    const input = event.target as HTMLInputElement;
    const fileList: FileList = input.files;
    if (fileList.length > 0)
    {
      const file: File = fileList[0];

      // Validate file size
      if ((file.size / 1024) > this.fileRestrictions.maxFileSize)
      {
        this.messageHandlerService.displayError('FILE-SIZE-EXCEED-LIMIT');
        return;
      }

      // Validate file extension
      let validExtension = false;
      this.fileRestrictions.allowedExtensions.forEach((ext: string) =>
      {
        if (file.name.toLowerCase().indexOf(ext) !== -1)
        {
          validExtension = true;
        }
      });
      if (!validExtension)
      {
        this.messageHandlerService.displayDirectMessage('error',
          this.invalidFileExtensionText.replace('{{value}}', this.fileRestrictions.allowedExtensions.join()));
        return;
      }
      this.memberForm.controls.insurances.controls[i].controls.cardDocumentName.setValue(file.name);
      this.memberForm.controls.insurances.controls[i].controls.cardDocumentMimeType.setValue(file.type);
      this.memberForm.markAsDirty();
      this.setFileFromBlob(file, i);
    }
  }

  public deleteInsuranceCard(i: number): void
  {
    this.isFileDeleted[i] = true;
    this.isNewFileSelected[i] = false;
    this.memberForm.controls.insurances.controls[i].controls.cardDocumentName.setValue(null);
    this.fileInput.nativeElement.value = '';
    this.memberForm.markAsDirty();
  }

  /**
   * View document handler
   *
   * @param url Document Url
   * @param description Document description
   * @param mediaType Media mime type
   * @param createdOn Document created date
   */
  public viewHandler(i: number): void
  {
    this.documentComponent.viewHandler(
      this.memberForm.controls.insurances.controls[i].controls.cardDocumentUrl.value,
      this.memberForm.controls.insurances.controls[i].controls.cardDocumentName.value,
      this.memberForm.controls.insurances.controls[i].controls.cardDocumentMimeType.value,
      null
    );
  }

  public addMemberChildren(id: number = null, childrenId: string = null, displayName: string = null,
    value: string = null, isLoading = false): void
  {
    this.memberForm.controls.memberChildren.push(this.initMemberChildren(id, childrenId, displayName, value));

    // Register value changes
    const controlIndex = this.memberForm.controls.memberChildren.controls.length - 1;
    this.memberForm.controls.memberChildren.controls[controlIndex].get('value').valueChanges.subscribe({
      next: () =>
      {
        this.calculateTotalChildren();
      }
    });

    if (!isLoading)
    {
      this.memberForm.markAsDirty();
    }
  }

  public addMemberAdult(id: number = null, adultId: string = null, displayName: string = null,
    value: string = null, isLoading = false): void
  {
    this.memberForm.controls.memberAdults.push(this.initMemberAdult(id, adultId, displayName, value));

    // Register value changes
    const controlIndex = this.memberForm.controls.memberAdults.controls.length - 1;
    this.memberForm.controls.memberAdults.controls[controlIndex].get('value').valueChanges.subscribe({
      next: () =>
      {
        this.calculateTotalAdults();
      }
    });

    if (!isLoading)
    {
      this.memberForm.markAsDirty();
    }
  }

  public checkPovertyLevel(): void
  {
    if (!this.householdSize.value)
    {
      this.messageHandlerService.displayWarning('SET-HOUSEHOLD-SIZE-FIRST');
      this.householdSizeControl.focus();
      return;
    }

    this.memberService.checkPovertyLevel(new Date().getFullYear().toString(), 'us',
      this.householdSize.value).subscribe({
        next: (poverty: any) =>
        {
          if (poverty && poverty.status === 200 && poverty.data.income)
          {
            this.povertyLevel.setValue(Number(poverty.data.income));
            this.povertyLastModifiedOn.setValue(new Date());
            this.memberForm.markAsDirty();
          }
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
  }

  public isOrganizationHasExtension(id: number): boolean
  {
    return this.extensionOrganizations.map(x => x.id).includes(id);
  }

  public formatExtensionValue(dataItem: any): string
  {
    return this.extensionService.formatExtensionValue(dataItem);
  }

  public showTooltip(e: ElementRef): void
  {
    this.tooltipDir.toggle(e, true);
  }

  public hideTooltip(): void
  {
    this.tooltipDir.hide();
  }

  /**
   * Disable inactive items from drop-down.
   *
   * @param itemArgs Item object
   */
  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  /**
   * Filters the organizations based on user input.
   */
  public filterRestrictedOrganizations(filter: string): void
  {
    this.searchTerm = filter;
    this.organizationsFiltered = this.restrictedOrganizations
      .filter(fa => fa.name.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Set the selected file.
   *
   * @param file Selected file.
   */
  private setFileFromBlob(file: Blob, i: number): void
  {
    const reader = new FileReader();
    reader.addEventListener('load', () =>
    {
      this.selectedCardFile[i] = reader.result;
      this.isNewFileSelected[i] = true;
      this.isFileDeleted[i] = false;
    }, false);
    reader.readAsDataURL(file);
  }

  private doDatesOverlap(range1: any, range2: any): boolean
  {
    return (!(range1.endDate.value < range2.startDate.value || range1.startDate.value > range2.endDate.value));
  }

  private onSubmit(): void
  {
    if (this.insurancesEnabled)
    {
      if (this.isRequired('MEDICAL_INSURANCE') && this.memberForm.controls.insurances.controls.length < 1)
      {
        this.messageHandlerService.displayDirectMessage('error',
          this.insuranceMissing.replace('{{patientLabel}}', this.patientLabelString));
        this.tabstrip.selectTab(4);
        this.applyAction = false;
        return;
      }

      // check End Date must be greater than Start Date
      for (let i = 0; i < this.memberForm.controls.insurances.controls.length; i++)
      {
        if (!this.memberForm.controls.insurances.controls[i].controls.deleted.value &&
          this.memberForm.controls.insurances.controls[i].controls.startDate.value !== null &&
          this.memberForm.controls.insurances.controls[i].controls.endDate.value !== null)
        {
          const d1 = moment(this.memberForm.controls.insurances.controls[i].controls.endDate.value);
          const d2 = moment(this.memberForm.controls.insurances.controls[i].controls.startDate.value);
          const diffMins = d1.diff(d2, 'minutes');
          if (diffMins <= 0)
          {
            const insurerName = this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.id ?
              this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.name : '';
            this.messageHandlerService.displayDirectMessage('error', this.dateRangeError.replace('{{insurer}}', insurerName));
            this.tabstrip.selectTab(4);
            this.applyAction = false;
            return;
          }
        }
      }

      // check date periods overlap
      for (let i = 0; i < this.memberForm.controls.insurances.controls.length; i++)
      {
        if (!this.memberForm.controls.insurances.controls[i].controls.deleted.value &&
          this.memberForm.controls.insurances.controls[i].controls.startDate.value !== null &&
          this.memberForm.controls.insurances.controls[i].controls.endDate.value !== null)
        {
          for (let j = i + 1; j < this.memberForm.controls.insurances.controls.length; j++)
          {
            if (!this.memberForm.controls.insurances.controls[j].controls.deleted.value &&
              this.memberForm.controls.insurances.controls[j].controls.startDate.value !== null &&
              this.memberForm.controls.insurances.controls[j].controls.endDate.value !== null)
            {
              if (this.doDatesOverlap(this.memberForm.controls.insurances.controls[i].controls, this.memberForm.controls.insurances.controls[j].controls))
              {
                if (this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.id === this.memberForm.controls.insurances.controls[j].controls.insurer?.value?.id)
                {
                  const insurerName = this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.id ?
                    this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.name : '';
                  this.messageHandlerService.displayDirectMessage('warning', this.insuranceDatesOverlap.replace('{{insurerName}}', insurerName));
                }
                else
                {
                  const insurerName = this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.id ?
                    this.memberForm.controls.insurances.controls[i].controls.insurer?.value?.name : '';
                  const insurerName2 = this.memberForm.controls.insurances.controls[j].controls.insurer?.value?.id ?
                    this.memberForm.controls.insurances.controls[j].controls.insurer?.value?.name : '';
                  this.messageHandlerService.displayDirectMessage('warning', this.insuranceDatesOverlapTwoInsurers.replace('{{insurerName}}', insurerName).replace('{{insurerName2}}', insurerName2));
                }
                break;
              }
            }
          }
        }
      }
    }

    // Validate Preferred Contact Method vs the field
    if (this.preferredContactMethods.value && this.preferredContactMethods.value !== '') 
    {
      for (let i = 0; i <= this.preferredContactMethods.value.length; i++) 
      {
        switch (this.preferredContactMethods.value[i])
        {
          case 'HOME':
          case 'CELL':
          case 'WORK':
          case 'OTHER':
          case 'PAGER':
          case 'EMAIL':
            if ((this.preferredContactMethods.value[i] === 'HOME' && (!this.homePhone.value || this.homePhone.value === '')) ||
              (this.preferredContactMethods.value[i] === 'CELL' && (!this.cellPhone.value || this.cellPhone.value === '')) ||
              (this.preferredContactMethods.value[i] === 'WORK' && (!this.workPhoneNumber.value || this.workPhoneNumber.value === '')) ||
              (this.preferredContactMethods.value[i] === 'OTHER' && (!this.otherPhoneNumber.value || this.otherPhoneNumber.value === '')) ||
              (this.preferredContactMethods.value[i] === 'PAGER' && (!this.pagerNumber.value || this.pagerNumber.value === '')) ||
              (this.preferredContactMethods.value[i] === 'EMAIL' && (!this.email.value || this.email.value === ''))
            )
            {
              this.displayPreferredContactError(this.preferredContactMethods.value[i]);
              this.tabstrip.selectTab(1);
              this.applyAction = false;
              return;
            }
            break;
        }
      }
    }

    // Other Names
    if (this.firstOrLastNameRequired)
    {
      for (let i = 0; i < this.memberForm.controls.otherNames.controls.length; i++)
      {
        if (
          ((this.memberForm.controls.otherNames.controls[i].controls.givenName === undefined) ||
            ((this.memberForm.controls.otherNames.controls[i].controls.givenName !== undefined) &&
              (this.memberForm.controls.otherNames.controls[i].controls.givenName.value === null || this.memberForm.controls.otherNames.controls[i].controls.givenName.value === ''))) &&
          ((this.memberForm.controls.otherNames.controls[i].controls.familyName === undefined) ||
            ((this.memberForm.controls.otherNames.controls[i].controls.familyName !== undefined) &&
              (this.memberForm.controls.otherNames.controls[i].controls.familyName.value === null || this.memberForm.controls.otherNames.controls[i].controls.familyName.value === '')))
        )
        {
          this.messageHandlerService.displayWarning('REQUIRED-FIRST-OR-LAST-NAME');
          let tabIndex = 11;
          if (!this.insurancesEnabled) { tabIndex -= 1; }
          if (!(this.allowTribalPerUserOrganization && (this.allTribalAffiliations.length > 0 || this.allTribalEnrollments.length > 0))) { tabIndex -= 1; }
          if (!(this.patientExtensionsEditable || this.viewExtensions?.gridData?.total > 0)) { tabIndex -= 1; }
          if (!(this.patientContactTeams && !this.isNew)) { tabIndex -= 1; }
          this.tabstrip.selectTab(tabIndex);
          this.applyAction = false;
          return;
        }
      }
    }

    for (let i = 0; i < this.memberForm.controls.insurances.controls.length; i++)
    {
      // Set insurance card
      if (this.isNewFileSelected[i])
      {
        const base64 = this.selectedCardFile[i].split('base64,')[1];
        this.memberForm.controls.insurances.controls[i].controls.card.setValue(base64);
      }
      else if (this.isFileDeleted[i])
      {
        this.memberForm.controls.insurances.controls[i].controls.deleteCard.setValue(true);
      }
      else
      {
        this.memberForm.controls.insurances.controls[i].controls.card.setValue(null);
      }

      // If no card or deleted, remove other properties
      if (!this.memberForm.controls.insurances.controls[i].controls.card ||
        this.memberForm.controls.insurances.controls[i].controls.deleteCard)
      {
        delete this.memberForm.controls.insurances.controls[i].controls.cardDocumentName;
        delete this.memberForm.controls.insurances.controls[i].controls.cardDocumentMimeType;
      }
    }

    let primaryAddress = 0;
    for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
    {
      if (this.memberForm.controls.addresses.controls[i].controls.isPrimary.value === true)
      {
        primaryAddress++;
      }
    }
    if (primaryAddress > 1)
    {
      this.messageHandlerService.displayWarning('MULTIPLE-PRIMARY-ADDRESSES');
      this.tabstrip.selectTab(2);
      this.applyAction = false;
      return;
    }
    else
      if (primaryAddress === 0 && this.memberForm.controls.addresses.controls.length > 0)
      {
        this.messageHandlerService.displayWarning('PRIMARY-ADDRESS-NOT-SET');
        this.tabstrip.selectTab(2);
        this.applyAction = false;
        return;
      }

    // save the Primary to Address
    for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
    {
      if (this.memberForm.controls.addresses.controls[i].controls.isPrimary.value === true)
      {
        this.addressTypeCode.setValue(this.memberForm.controls.addresses.controls[i].controls.addressType.value.code);
        this.street.setValue(this.memberForm.controls.addresses.controls[i].controls.streetLine.value);
        this.streetLineAdditional.setValue(this.memberForm.controls.addresses.controls[i].controls.streetLineAdditional.value);
        this.city.setValue(this.memberForm.controls.addresses.controls[i].controls.city.value);
        this.county.setValue(this.memberForm.controls.addresses.controls[i].controls.county.value);
        this.postalCode.setValue(this.memberForm.controls.addresses.controls[i].controls.postalCode.value);
        this.stateCode.setValue(this.memberForm.controls.addresses.controls[i].controls.state.value != null ?
          this.memberForm.controls.addresses.controls[i].controls.state.value.code : null);
        this.countryCode.setValue(this.memberForm.controls.addresses.controls[i].controls.country.value != null ?
          this.memberForm.controls.addresses.controls[i].controls.country.value.code : null);
        this.longitude.setValue(this.memberForm.controls.addresses.controls[i].controls.longitude.value);
        this.latitude.setValue(this.memberForm.controls.addresses.controls[i].controls.latitude.value);
        break;
      }
    }

    this.saving = true;

    const member: any = {
      id: this.clonedMember !== undefined ? this.clonedMember.id : null,
      version: this.clonedMember !== undefined ? this.clonedMember.version : null,
      givenName: this.firstName.value,
      middleName: this.middleName.value,
      familyName: this.lastName.value,
      dateOfBirth: this.dateOfBirth.value,
      gender: this.gender.value,
      administrativeGender: this.administrativeGender.value,
      raceEthnicities: this.raceEthnicities.value,
      educationLevel: this.educationLevel.value,
      employmentStatus: this.employmentStatus.value,
      maritalStatus: this.maritalStatus.value,
      religiousAffiliation: this.religiousAffiliation.value,
      spokenLanguages: this.spokenLanguages.value,
      memberWrittenLanguages: this.writtenLanguages.value,
      memberReadingLanguages: this.readingLanguages.value,
      memberOrganizations: this.memberOrganizations.value,
      enhancedServices: this.enhancedServices.value,
      email: this.email.value,
      homePhoneNumber: this.homePhone.value,
      homePhoneSafe: this.homePhoneSafe.value,
      workPhoneNumber: this.workPhoneNumber.value,
      workPhoneNumberExtension: this.workPhoneNumberExtension.value,
      workPhoneSafe: this.workPhoneSafe.value,
      otherPhoneNumber: this.otherPhoneNumber.value,
      otherPhoneSafe: this.otherPhoneSafe.value,
      cellPhoneNumber: this.cellPhone.value,
      cellPhoneSafe: this.cellPhoneSafe.value,
      pagerNumber: this.pagerNumber.value,
      pagerSafe: this.pagerSafe.value,
      faxNumber: this.faxNumber.value,
      faxSafe: this.faxSafe.value,
      url: this.url.value,
      streetLine: this.street.value,
      streetLineAdditional: this.streetLineAdditional.value,
      city: this.city.value,
      county: this.county.value,
      stateCode: this.stateCode.value,
      postalCode: this.postalCode.value,
      countryCode: this.countryCode.value,
      addressTypeCode: this.addressTypeCode.value,
      longitude: this.longitude.value,
      latitude: this.latitude.value,
      preferredVideoProvider: this.preferredVideoProvider.value,
      veteranStatus: this.veteranStatus.value,
      housingStatus: this.housingStatus.value,
      householdSize: this.householdSize.value,
      dependents: this.dependents.value,
      optOutDate: this.optOutDate.value,
      optOutReason: this.optOutReason.value,
      preferredName: this.preferredName.value,
      familyIncome: this.familyIncome.value,
      familyIncomeUnknownDeclined: this.familyIncomeUnknownDeclined.value,
      povertyLevel: this.povertyLevel.value,
      povertyLastModifiedOn: this.povertyLastModifiedOn.value,
      identifiers: this.identifiers.getRawValue(),  // getRawValue() returns the full form value including disabled controls so existing identifiers keep their value and source when saving (e.g. after adding a new identifier)      
      addresses: this.addresses.value,
      insurances: this.insurances.value,
      memberChildren: this.memberChildren.value,
      memberAdults: this.memberAdults.value,
      otherNames: this.otherNames.value,
      channelId: this.channelId !== undefined ? this.channel.value : null,
      managerId: this.channelId !== undefined && this.manager.value ? this.manager.value.id : null,
      preferredLanguage: this.preferredLanguage.value,
      notificationType: this.notificationType.value,
      namePronoun: this.namePronoun.value,
      namePronounOther: this.namePronounOther.value,
      englishProficiency: this.englishProficiency.value,
      interpreterNeed: this.interpreterNeed.value,
      interpreterNeedOther: this.interpreterNeedOther.value,
      livesAlone: this.livesAlone.value,
      primaryCaregiver: this.primaryCaregiver.value,
      races: this.races.value,
      sexualOrientation: this.sexualOrientation.value,
      tribalAffiliated: this.tribalAffiliated.value,
      tribalAffiliations: this.tribalAffiliated.value ? this.tribalAffiliations.value : [],
      tribalEnrolled: this.tribalEnrolled.value,
      tribalEnrollments: this.tribalEnrolled.value ? this.tribalEnrollments.value : []
    };

    member.extensions = this.viewExtensions.gridData.data;

    // Check if member exists
    if (this.isNew)
    {
      const dob = moment(member.dateOfBirth).format('YYYY-MM-DD').toString();
      const memberCheck: MemberCheck = {
        givenName: member.givenName,
        familyName: member.familyName,
        dateOfBirth: dob
      };
      this.memberService.memberExists(memberCheck).subscribe({
        next: (memberExists) =>
        {
          if (memberExists)
          {
            this.memberToSave = member;
            this.memberExistsDialogOpened = true;
            this.saving = false;
          }
          else
          {
            this.performMemberSave(member);
          }
        }
      });
    }
    else
    {
      this.performMemberSave(member);
    }
  }

  private performMemberSave(member: any): void
  {
    this.saving = true;
    this.memberToSave = member;

    let save = this.memberForm.controls.addresses.controls.length === 0;

    for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
    {
      if (this.memberForm.controls.addresses.controls[i].controls.isPrimary.value === true &&
        this.addressChanged[i] && this.memberForm.controls.addresses.controls[i].controls.streetLine.value)
      {
        this.addressValidator.execute(true,
          this.memberForm.controls.addresses.controls[i].controls.streetLine.value,
          this.memberForm.controls.addresses.controls[i].controls.streetLineAdditional.value,
          this.memberForm.controls.addresses.controls[i].controls.city.value,
          this.memberForm.controls.addresses.controls[i].controls.state.value != null ?
            this.memberForm.controls.addresses.controls[i].controls.state.value.code : null,
          this.memberForm.controls.addresses.controls[i].controls.country.value != null ?
            this.memberForm.controls.addresses.controls[i].controls.country.value.code : null,
          this.memberForm.controls.addresses.controls[i].controls.postalCode.value,
          i);
        save = false;
        break;
      }
      else
      {
        save = true;
      }
    }
    if (save)
    {
      this.savePatient();
    }
  }

  /**
   * Return the required validator if the field is required.
   *
   * @param demographic Demographic field to check.
   * @returns Validators.required or null if the field is optional
   */
  private getRequiredValidator(demographic: string, dictionaryCount: number = null)
  {
    if (this.isRequired(demographic) && (dictionaryCount === null || dictionaryCount > 0))
    {
      if (demographic === 'GENDER')
      {
        return this.showGender ? Validators.required : null;
      }
      else
        if (demographic === 'ADMINISTRATIVE_GENDER')
        {
          return this.showAdministrativeGender ? Validators.required : null;
        }
        else
        {
          return (demographic === 'URL') ? [Validators.pattern(this.urlPattern), Validators.required] : Validators.required;
        }
    }
    else
    {
      return (demographic === 'URL') ? Validators.pattern(this.urlPattern) : null;
    }
  }

  private getRequiredValidatorInsurance(insuranceField: string)
  {
    if (this.isRequiredInsurance(insuranceField))
    {
      return Validators.required;
    }
    else
    {
      return null;
    }
  }

  private buildForm(disableManager: any): void
  {
    this.translate.get(['SELECT-INSURER', 'INVALID-FILE-TYPE', 'DATE-RANGE-ERROR-INSURANCE', 'INSURANCE-MISSING',
      'OTHER-CONTACTS', 'INSURANCE-DATES-OVERLAP', 'INSURANCE-DATES-OVERLAP-TWO-INSURERS']).subscribe({
        next: (res) =>
        {
          this.defaultInsurerItem = { name: res['SELECT-INSURER'], id: null, active: true };
          this.invalidFileExtensionText = res['INVALID-FILE-TYPE'];
          this.dateRangeError = res['DATE-RANGE-ERROR-INSURANCE'];
          this.insuranceMissing = res['INSURANCE-MISSING'];
          this.otherContactsText = res['OTHER-CONTACTS'];
          this.insuranceDatesOverlap = res['INSURANCE-DATES-OVERLAP'];
          this.insuranceDatesOverlapTwoInsurers = res['INSURANCE-DATES-OVERLAP-TWO-INSURERS'];
        }
      });

    this.insurerService.getInsurerList().subscribe({
      next: (data) =>
      {
        this.insurers = data;
        this.handleInsurerFilter('');
      }
    });

    this.isHeadOfHousehold = this.clonedMember !== undefined ? this.clonedMember.headOfHousehold : false;
    this.memberExistsDialogOpened = false;
    this.pendingConsents = [];
    this.deletedConsents = [];
    this.totalChildren = 0;
    this.totalAdults = 0;

    const memberWrittenLanguages = [];
    if ((this.clonedMember !== undefined) &&
      (this.clonedMember.memberWrittenLanguages !== null) &&
      (this.clonedMember.memberWrittenLanguages !== undefined))
    {
      this.clonedMember.memberWrittenLanguages.forEach(d =>
      {
        memberWrittenLanguages.push(d.writtenLanguage);
      });
    }

    const memberReadingLanguages = [];
    if ((this.clonedMember !== undefined) &&
      (this.clonedMember.memberReadingLanguages !== null) &&
      (this.clonedMember.memberReadingLanguages !== undefined))
    {
      this.clonedMember.memberReadingLanguages.forEach(d =>
      {
        memberReadingLanguages.push(d.readingLanguage);
      });
    }

    const memberOrganizations = [];
    if ((this.clonedMember !== undefined) &&
      (this.clonedMember.memberOrganizations !== null) &&
      (this.clonedMember.memberOrganizations !== undefined))
    {
      this.restrictedOrganizations.forEach((organization) =>
      {
        organization.recordId = null;
        organization.recordVersion = null;
        const memberOrganization = this.clonedMember.memberOrganizations.find((mo: any) => mo.organizationId === organization.id);
        if (memberOrganization)
        {
          memberOrganizations.push({
            recordId: memberOrganization.id,
            recordVersion: memberOrganization.version,
            id: organization.id,
            name: organization.name
          });
          organization.recordId = memberOrganization.id;
          organization.recordVersion = memberOrganization.version;
        }
      });
    }

    let caseManager = null;
    if (this.channelId !== undefined && this.memberForm !== undefined && this.manager.value)
    {
      if (this.manager.value.id !== undefined)
      {
        caseManager = this.caseManagers.filter(manager => manager.id == this.manager.value.id);
      }
      else
      {
        caseManager = this.caseManagers.filter(manager => manager.id == this.manager.value[0].id);
      }
    }

    this.memberForm = this.formBuilder.group({
      id: this.clonedMember !== undefined ? this.clonedMember.id : null,
      version: this.clonedMember !== undefined ? this.clonedMember.version : null,
      firstName: [{
        value: this.clonedMember !== undefined ?
          this.clonedMember.name.givenName : null, disabled: this.isReadOnly || this.clonedMember?.testMember
      }, this.getRequiredValidator('FIRST_NAME')],
      lastName: [{
        value: this.clonedMember !== undefined ?
          this.clonedMember.name.familyName : null, disabled: this.isReadOnly || this.clonedMember?.testMember
      }, this.getRequiredValidator('LAST_NAME')],
      middleName: { value: this.clonedMember !== undefined ? this.clonedMember.name.middleName : null, disabled: this.isReadOnly },
      dateOfBirth: [{
        value: this.clonedMember !== undefined && this.clonedMember.dateOfBirth !== null ?
          new Date(`${this.clonedMember.dateOfBirth}T12:00:00.000`) : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('DATE_OF_BIRTH')],
      gender: [{
        value: this.clonedMember !== undefined && this.clonedMember.gender !== null ?
          this.clonedMember.gender.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('GENDER', this.genders.length)],
      administrativeGender: [{
        value: this.clonedMember !== undefined && this.clonedMember.administrativeGender !== null ?
          this.clonedMember.administrativeGender.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('ADMINISTRATIVE_GENDER', this.genders.length)],
      raceEthnicities: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.raceEthnicities !== null &&
          this.clonedMember.raceEthnicities !== undefined ?
          this.clonedMember.raceEthnicities : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('RACE_ETHNICITIES', this.allRaceEthnicities.length)],
      educationLevel: [{
        value: this.clonedMember !== undefined && this.clonedMember.educationLevel !== null ?
          this.clonedMember.educationLevel.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('EDUCATION_LEVEL', this.educationLevels.length)],
      employmentStatus: [{
        value: this.clonedMember !== undefined && this.clonedMember.employmentStatus !== null ?
          this.clonedMember.employmentStatus.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('EMPLOYMENT_STATUS', this.employmentStatuses.length)],
      maritalStatus: [{
        value: this.clonedMember !== undefined && this.clonedMember.maritalStatus !== null ?
          this.clonedMember.maritalStatus.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('MARITAL_STATUS', this.maritalStatuses.length)],
      religiousAffiliation: [{
        value: this.clonedMember !== undefined && this.clonedMember.religiousAffiliation !== null ?
          this.clonedMember.religiousAffiliation.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('RELIGIOUS_AFFILIATION', this.religiousAffiliations.length)],
      spokenLanguages: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.spokenLanguages !== null &&
          this.clonedMember.spokenLanguages !== undefined ?
          this.clonedMember.spokenLanguages : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('SPOKEN_LANGUAGES', this.allSpokenLanguages.length)],
      writtenLanguages: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.memberWrittenLanguages !== null &&
          this.clonedMember.memberWrittenLanguages !== undefined ?
          memberWrittenLanguages : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('WRITTEN_LANGUAGES', this.allWrittenLanguages.length)],
      readingLanguages: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.memberReadingLanguages !== null &&
          this.clonedMember.memberReadingLanguages !== undefined ?
          memberReadingLanguages : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('READING_LANGUAGES', this.allReadingLanguages.length)],
      memberOrganizations: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.memberOrganizations !== null &&
          this.clonedMember.memberOrganizations !== undefined ?
          memberOrganizations : null, disabled: this.isReadOnly || !this.authorizedOrganizationsEditable
      }],
      enhancedServices: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.enhancedServices !== null &&
          this.clonedMember.enhancedServices !== undefined ?
          this.clonedMember.enhancedServices : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('ENHANCED_SERVICE_ELIGIBILITY', this.allEnhancedServices.length)],
      homePhone: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.homePhoneNumber : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('HOME_PHONE')],
      homePhoneSafe: [{
        value: this.clonedMember !== undefined && this.clonedMember.homePhoneSafe !== null ?
          this.clonedMember.homePhoneSafe : null, disabled: this.isReadOnly
      }, false],
      workPhoneNumber: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.workPhoneNumber : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('WORK_PHONE')],
      workPhoneNumberExtension: {
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.workPhoneNumberExtension : null, disabled: this.isReadOnly
      },
      workPhoneSafe: [{
        value: this.clonedMember !== undefined && this.clonedMember.workPhoneSafe !== null ?
          this.clonedMember.workPhoneSafe : null, disabled: this.isReadOnly
      }, false],
      otherPhoneNumber: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.otherPhoneNumber : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('OTHER_PHONE')],
      otherPhoneSafe: [{
        value: this.clonedMember !== undefined && this.clonedMember.otherPhoneSafe !== null ?
          this.clonedMember.otherPhoneSafe : null, disabled: this.isReadOnly
      }, false],
      cellPhone: {
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.cellPhoneNumber : null, disabled: this.isReadOnly
      },
      cellPhoneSafe: [{
        value: this.clonedMember !== undefined && this.clonedMember.cellPhoneSafe !== null ?
          this.clonedMember.cellPhoneSafe : null, disabled: this.isReadOnly
      }, false],
      pagerNumber: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.pagerNumber : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('PAGER')],
      pagerSafe: [{
        value: this.clonedMember !== undefined && this.clonedMember.pagerSafe !== null ?
          this.clonedMember.pagerSafe : null, disabled: this.isReadOnly
      }, false],
      faxNumber: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.faxNumber : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('FAX')],
      faxSafe: [{
        value: this.clonedMember !== undefined && this.clonedMember.faxSafe !== null ?
          this.clonedMember.faxSafe : null, disabled: this.isReadOnly
      }, false],
      url: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.url : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('URL')],
      email: {
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null ?
          this.clonedMember.contact.email : null, disabled: this.isReadOnly
      },
      street: this.clonedMember !== undefined && this.clonedMember.address !== null ?
        this.clonedMember.address.streetLine : null,
      streetLineAdditional: this.clonedMember !== undefined && this.clonedMember.address !== null ?
        this.clonedMember.address.streetLineAdditional : null,
      city: this.clonedMember !== undefined && this.clonedMember.address !== null ?
        this.clonedMember.address.city : null,
      county: this.clonedMember !== undefined && this.clonedMember.address !== null ?
        this.clonedMember.address.county : null,
      stateCode: this.clonedMember !== undefined && this.clonedMember.address !== null && this.clonedMember.address.state !== null ?
        this.clonedMember.address.state.code : null,
      postalCode: this.clonedMember !== undefined && this.clonedMember.address !== null ?
        this.clonedMember.address.postalCode : null,
      countryCode: this.clonedMember !== undefined && this.clonedMember.address !== null && this.clonedMember.address.country !== null ?
        this.clonedMember.address.country.code : null,
      addressTypeCode: this.clonedMember !== undefined && this.clonedMember.address !== null &&
        this.clonedMember.address.addressType !== null ? this.clonedMember.address.addressType.code : null,
      longitude: null,
      latitude: null,
      preferredVideoProvider: [{
        value: this.clonedMember !== undefined && this.clonedMember.contact !== null &&
          this.clonedMember.contact.preferredVideoProvider !== null ?
          this.clonedMember.contact.preferredVideoProvider.id : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('VIDEO_PROVIDER', this.videoProviders.length)],
      veteranStatus: [{
        value: this.clonedMember !== undefined && this.clonedMember.veteranStatus !== null ?
          this.clonedMember.veteranStatus.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('VETERAN_STATUS', this.veteranStatuses.length)],
      housingStatus: [{
        value: this.clonedMember !== undefined && this.clonedMember.housingStatus !== null ?
          this.clonedMember.housingStatus.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('HOUSING', this.housingStatuses.length)],
      householdSize: [{
        value: this.clonedMember !== undefined ? this.clonedMember.householdSize : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('HOUSEHOLD_SIZE')],
      dependents: [{
        value: this.clonedMember !== undefined ? this.clonedMember.dependents : null, disabled: this.isReadOnly
      }, this.showDependents ? this.getRequiredValidator('DEPENDENTS') : null],
      optOutDate: [{
        value: this.clonedMember !== undefined ? this.clonedMember.optOutDate : null, disabled: this.isReadOnly
      }],
      optOutReason: [{
        value: this.clonedMember !== undefined ? this.clonedMember.optOutReason : null, disabled: this.isReadOnly
      }],
      preferredContactMethods: [{
        value: this.clonedMember !== undefined ? this.clonedMember.preferredContactMethods : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('PREFERRED_CONTACT_METHODS')],
      preferredName: [{
        value: this.clonedMember !== undefined ? this.clonedMember.name.preferredName : null, disabled: this.isReadOnly || this.clonedMember?.testMember
      }, this.getRequiredValidator('PREFERRED_NAME')],
      familyIncome: {
        value: this.clonedMember !== undefined ? this.clonedMember.familyIncome : null, disabled: this.isReadOnly
      }, // familyIncome required validator handled in valueChanges
      familyIncomeUnknownDeclined: {
        value: this.clonedMember !== undefined && this.clonedMember.familyIncomeUnknownDeclined !== null ?
          this.clonedMember.familyIncomeUnknownDeclined : null, disabled: this.isReadOnly
      }, // familyIncomeUnknownDeclined required validator handled in valueChanges
      povertyLevel: [{
        value: this.clonedMember !== undefined ? this.clonedMember.povertyLevel : null, disabled: this.isReadOnly || this.povertyAPIEnabled
      }],
      povertyLastModifiedOn: [{
        value: this.clonedMember !== undefined && this.clonedMember.povertyLastModifiedOn !== null ? this.clonedMember.povertyLastModifiedOn : null,
        disabled: this.isReadOnly
      }],
      preferredLanguage: [{
        value: this.clonedMember !== undefined ? this.clonedMember.preferredLanguage : null,
        disabled: this.isReadOnly
      }, this.getRequiredValidator('NOTIFICATION_LANGUAGE')],
      notificationType: [{
        value: this.clonedMember !== undefined ? this.clonedMember.notificationType : null,
        disabled: this.isReadOnly
      }, this.getRequiredValidator('NOTIFICATION')],
      identifiers: this.fb.array([]),
      addresses: this.fb.array([]),
      insurances: this.fb.array([]),
      memberChildren: this.fb.array([]),
      memberAdults: this.fb.array([]),
      otherNames: this.fb.array([]),
      channel: { value: this.channelId, disabled: this.isReadOnly },
      manager: {
        value: caseManager,
        disabled: this.isReadOnly || disableManager
      },
      namePronoun: [{
        value: this.clonedMember !== undefined && this.clonedMember.namePronoun !== null ?
          this.clonedMember.namePronoun.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('NAME_PRONOUN', this.namePronouns.length)],
      namePronounOther: [{
        value: this.clonedMember !== undefined && this.clonedMember.namePronounOther !== null ?
          this.clonedMember.namePronounOther : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('NAME_PRONOUN_OTHER', this.namePronouns.length)],
      englishProficiency: [{
        value: this.clonedMember !== undefined && this.clonedMember.englishProficiency !== null ?
          this.clonedMember.englishProficiency.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('ENGLISH_PROFICIENCY', this.englishProficiencies.length)],
      interpreterNeed: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.interpreterNeed !== null &&
          this.clonedMember.interpreterNeed !== undefined &&
          this.clonedMember.interpreterNeed.code !== undefined ?
          this.clonedMember.interpreterNeed.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('INTERPRETER_NEED', this.interpreterNeeds.length)],
      interpreterNeedOther: [{
        value: this.clonedMember !== undefined && this.clonedMember.interpreterNeedOther !== null ?
          this.clonedMember.interpreterNeedOther : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('INTERPRETER_NEED_OTHER', this.interpreterNeeds.length)],
      livesAlone: [{
        value: this.clonedMember !== undefined && this.clonedMember.livesAlone !== null ?
          this.clonedMember.livesAlone : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('LIVES_ALONE')],
      primaryCaregiver: [{
        value: this.clonedMember !== undefined && this.clonedMember.primaryCaregiver !== null ?
          this.clonedMember.primaryCaregiver : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('PRIMARY_CAREGIVER')],
      races: [{
        value: this.clonedMember !== undefined &&
          this.clonedMember.races !== null &&
          this.clonedMember.races !== undefined ?
          this.clonedMember.races : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('RACES', this.allRaces.length)],
      sexualOrientation: [{
        value: this.clonedMember !== undefined && this.clonedMember.sexualOrientation !== null ?
          this.clonedMember.sexualOrientation.code : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('SEXUAL_ORIENTATION', this.sexualOrientations.length)],
      tribalAffiliated: [{
        value: this.clonedMember !== undefined && this.clonedMember.tribalAffiliated !== null ?
          this.clonedMember.tribalAffiliated : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('TRIBAL_AFFILIATED', this.allTribalAffiliations.length)],
      tribalAffiliations: {
        value: this.clonedMember !== undefined &&
          this.clonedMember.tribalAffiliations !== null &&
          this.clonedMember.tribalAffiliations !== undefined ?
          this.clonedMember.tribalAffiliations : null, disabled: this.isReadOnly
      }, // tribalAffiliations required validator handled in valueChanges
      tribalEnrolled: [{
        value: this.clonedMember !== undefined && this.clonedMember.tribalEnrolled !== null ?
          this.clonedMember.tribalEnrolled : null, disabled: this.isReadOnly
      }, this.getRequiredValidator('TRIBAL_ENROLLED', this.allTribalEnrollments.length)],
      tribalEnrollments: {
        value: this.clonedMember !== undefined &&
          this.clonedMember.tribalEnrollments !== null &&
          this.clonedMember.tribalEnrollments !== undefined ?
          this.clonedMember.tribalEnrollments : null, disabled: this.isReadOnly
      }, // tribalEnrollments required validator handled in valueChanges
      extensions: [{
        value: this.clonedMember !== undefined && this.clonedMember.extensions !== null ?
          this.clonedMember.extensions : [], disabled: false
      }],
    });

    this.manager.setValidators(this.channelId !== undefined && this.selectedChannel !== undefined
      && this.selectedChannel.caseManagerAssignmentMode === null ? [Validators.required] : []);

    this.notificationChanged(this.notificationType.value);
    this.notificationType.valueChanges.subscribe({
      next: (notification: string) =>
      {
        this.notificationChanged(notification);
      }
    });

    // valueChanges household size to reset poverty level if not set
    this.householdSize.valueChanges.subscribe({
      next: () =>
      {
        if (this.povertyAPIEnabled)
        {
          if (!this.householdSize.value || this.householdSize.value === 0)
          {
            setTimeout(() =>
            {
              this.povertyLevel.setValue(null);
              this.povertyLastModifiedOn.setValue(null);
              this.povertyLevel.updateValueAndValidity();
              this.povertyLastModifiedOn.updateValueAndValidity();
            }, 500);
          }
          else
          {
            this.checkPovertyLevel();
          }
        }
      }
    });

    // Family Income and Unknown/Declined

    this.setControlsStateFamilyIncome();
    this.setControlsStateUnknownDeclined();
    this.familyIncome.valueChanges.subscribe({ next: () => { this.setControlsStateFamilyIncome(); } });
    this.familyIncomeUnknownDeclined.valueChanges.subscribe({ next: () => { this.setControlsStateUnknownDeclined(); } });

    this.tribalAffiliatedChanged(this.tribalAffiliated.value);
    this.tribalAffiliated.valueChanges.subscribe({
      next: (value: boolean) =>
      {
        this.tribalAffiliatedChanged(value);
      }
    });

    this.tribalEnrolledChanged(this.tribalEnrolled.value);
    this.tribalEnrolled.valueChanges.subscribe({
      next: (value: boolean) =>
      {
        this.tribalEnrolledChanged(value);
      }
    });

    if (this.clonedMember !== undefined)
    {
      if (this.clonedMember.identifiers)
      {
        // This is a work around to make sure data.dictionary/data.sourceDictionary are objects
        // to avoid converting the member being returned to memberDTO.
        const dictionaries = [];
        this.clonedMember.identifiers.forEach(data =>
        {
          if (typeof data.dictionary === 'object')
          {
            if (data.dictionary !== null)
            {
              dictionaries.push(data.dictionary);
            }
          }
          if (typeof data.sourceDictionary === 'object')
          {
            if (data.sourceDictionary !== null)
            {
              dictionaries.push(data.sourceDictionary);
            }
          }
        });

        this.clonedMember.identifiers.forEach(data =>
        {
          if (typeof data.dictionary === 'number')
          {
            data.dictionary = dictionaries.find(x => x.id === data.dictionary);
          }
          if (typeof data.sourceDictionary === 'number')
          {
            data.sourceDictionary = dictionaries.find(x => x.id === data.sourceDictionary);
          }
          this.addIdentifier(data.id, data.version, data.dictionary, data.sourceDictionary, data.value, true);
        });
      }

      if (this.clonedMember.addresses)
      {
        // This is a work around to make sure data.stateCode/data.countryCode are objects
        // to avoid converting the member being returned to memberDTO.
        const dictionaries = [];
        this.clonedMember.addresses.forEach(data =>
        {
          if (typeof data.state === 'object')
          {
            if (data.state !== null)
            {
              dictionaries.push(data.state);
            }
          }
          if (typeof data.country === 'object')
          {
            if (data.country !== null)
            {
              dictionaries.push(data.country);
            }
          }
          if (typeof data.addressType === 'object')
          {
            if (data.addressType !== null)
            {
              dictionaries.push(data.addressType);
            }
          }
        });

        this.clonedMember.addresses.forEach(address =>
        {
          address.isPrimary = HelperUtils.isPrimaryAddress(address,
            this.street.value, this.streetLineAdditional.value, this.city.value, this.county.value, this.postalCode.value,
            this.stateCode.value, this.countryCode.value, this.addressTypeCode.value) ? 1 : 2;

          if (typeof address.state === 'number')
          {
            address.state = dictionaries.find(x => x.id === address.state);
          }
          if (typeof address.country === 'number')
          {
            address.country = dictionaries.find(x => x.id === address.country);
          }
          if (typeof address.addressType === 'number')
          {
            address.addressType = dictionaries.find(x => x.id === address.addressType);
          }
        });

        this.clonedMember.addresses = sortBy(this.clonedMember.addresses, ['isPrimary']);
        this.clonedMember.addresses.forEach(data =>
        {
          this.addAddress(data.id, data.addressType,
            this.member.address ? data.id === this.member.address.id : false, data.streetLine, data.streetLineAdditional,
            data.city, data.county, data.state, data.postalCode, data.country, null, null, true, false);
        });
      }

      if (this.clonedMember.insurances)
      {
        // This is a work around to make sure data.insurer are objects
        // to avoid converting the member being returned to memberDTO.
        const dictionaries = [];
        this.clonedMember.insurances.forEach(data =>
        {
          if (typeof data.insurer === 'object')
          {
            if (data.insurer !== null)
            {
              dictionaries.push(data.insurer);
            }
          }
        });

        this.clonedMember.insurances.forEach(insurance =>
        {
          if (typeof insurance.insurer === 'number')
          {
            insurance.insurer = dictionaries.find(x => x.id === insurance.insurer);
          }
        });

        this.clonedMember.insurances = sortBy(this.clonedMember.insurances, ['id']);
        this.clonedMember.insurances.forEach(data =>
        {
          data.startDate = data.startDate !== null ? new Date(`${data.startDate}T12:00:00.000`) : null;
          data.endDate = data.endDate !== null ? new Date(`${data.endDate}T12:00:00.000`) : null;
          this.addInsurance(data.id, data.insurer, data.startDate, data.endDate,
            data.insuredGivenName, data.insuredFamilyName, data.businessPhoneNumber,
            data.insuranceMemberId, data.plan, data.groupId,
            data.policyHolder, data.employer, data.insurerUrl,
            data.card, data.cardDocumentName, data.cardDocumentMimeType, data.deleteCard,
            data.cardDocumentId, data.cardDocumentDate, data.cardDocumentUrl, data.insuranceExternalId,
            false,    // Always set deleted=false since we load none deleted only
            true);
        });
        this.validateInsuranceDateControls();
      }

      if (this.clonedMember.memberChildren)
      {
        // Initialize member children
        this.totalChildrenCodeSet.forEach(data =>
        {
          const memberChild = this.clonedMember.memberChildren.find(x => x.childrenId === data.id);
          if (memberChild !== undefined)
          {
            this.addMemberChildren(memberChild.id, memberChild.childrenId, data.displayName, memberChild.value, true);
          }
          else
          {
            this.addMemberChildren(null, data.id, data.displayName, null, true);
          }
        });
      }

      if (this.clonedMember.memberAdults)
      {
        // Initialize member adults
        this.totalAdultsCodeSet.forEach(data =>
        {
          const memberAdult = this.clonedMember.memberAdults.find(x => x.adultId === data.id);
          if (memberAdult !== undefined)
          {
            this.addMemberAdult(memberAdult.id, memberAdult.adultId, data.displayName, memberAdult.value, true);
          }
          else
          {
            this.addMemberAdult(null, data.id, data.displayName, null, true);
          }
        });
      }

      if (this.clonedMember.otherNames)
      {
        // This is a work around to make sure data.dictionary/data.sourceDictionary are objects
        // to avoid converting the member being returned to memberDTO.
        const dictionaries = [];
        this.clonedMember.otherNames.forEach(data =>
        {
          if (typeof data.nameType === 'object')
          {
            if (data.nameType !== null)
            {
              dictionaries.push(data.nameType);
            }
          }
        });

        this.clonedMember.otherNames.forEach(data =>
        {
          if (typeof data.nameType === 'number')
          {
            data.nameType = dictionaries.find(x => x.id === data.nameType);
          }
          this.addOtherName(data.id, data.version, data.nameType, data.givenName, data.familyName, true);
        });
      }

      for (let i = 0; i < this.memberForm.controls.insurances.controls.length; i++)
      {
        this.isNewFileSelected[i] = false;
        this.isFileDeleted[i] = false;
        this.selectedCardFile[i] = null;
      }

      // Monitor address changes to not show address validator all the time.
      for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
      {
        this.addressChanged[i] = false;
      }

      for (let i = 0; i < this.memberForm.controls.addresses.controls.length; i++)
      {
        this.memberForm.controls.addresses.controls[i].controls.addressType.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.isPrimary.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.streetLine.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.streetLineAdditional.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.city.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.state.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.country.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
        this.memberForm.controls.addresses.controls[i].controls.postalCode.valueChanges.subscribe({
          next: () => { this.addressChanged[i] = true; }
        });
      }

      // This is a work around to make sure settingExtension.organization are objects
      // to avoid converting the member being returned to memberDTO.
      if (this.clonedMember.extensions)
      {
        const organizations = [];
        this.clonedMember.extensions.forEach(data =>
        {
          if (typeof data.settingExtension === 'object' && typeof data.settingExtension.organization === 'object')
          {
            if (data.settingExtension.organization !== null)
            {
              organizations.push(data.settingExtension.organization);
            }
          }
          data.lastModifiedOn = new Date(data.lastModifiedOn);
        });
        this.clonedMember.extensions.forEach(data =>
        {
          if (typeof data.settingExtension.organization === 'number')
          {
            data.settingExtension.organization = organizations.find(x => x.id === data.settingExtension.organization);
          }
        });
      }
      this.viewExtensions.setData(this.clonedMember.extensions ? this.clonedMember.extensions : []);
      this.viewExtensions.setSort([{ field: 'settingExtension.name', dir: 'asc' }]);
      this.setViewExtensionsColumnsVisibility();
    }
    else
    {
      // Initialize member children
      this.totalChildrenCodeSet.forEach(data =>
      {
        this.addMemberChildren(null, data.id, data.displayName, null, true);
      });

      // Initialize member adults
      this.totalAdultsCodeSet.forEach(data =>
      {
        this.addMemberAdult(null, data.id, data.displayName, null, true);
      });
    }

    this.memberForm.valueChanges.subscribe({
      next: () =>
      {
        this.saving = false;
      }
    });

    this.calculateTotalChildren();
    this.calculateTotalAdults();

    this.loading = false;
  }

  private setControlsStateFamilyIncome(): void
  {
    if (!this.inValueChanges)
    {
      this.inValueChanges = true;
      if (this.familyIncome.value === null || this.familyIncome.value === '')
      {
        if (!this.isReadOnly)
        {
          this.familyIncomeUnknownDeclined.enable({ emitEvent: false });
          this.setFamilyIncomeRequiredValidators();
        }
      }
      else
      {
        this.familyIncomeUnknownDeclined.disable({ emitEvent: false });
        this.familyIncomeUnknownDeclined.setValue(null, { emitEvent: false });
        this.setFamilyIncomeRequiredValidators();
      }
      this.familyIncome.updateValueAndValidity({ emitEvent: false });
      this.familyIncomeUnknownDeclined.updateValueAndValidity({ emitEvent: false });
      this.inValueChanges = false;
    }
  }

  private setControlsStateUnknownDeclined(): void
  {
    if (!this.inValueChanges)
    {
      this.inValueChanges = true;
      if (this.familyIncomeUnknownDeclined.value === true)
      {
        this.familyIncome.disable({ emitEvent: false });
        this.familyIncome.setValue(null, { emitEvent: false });
        this.setFamilyIncomeRequiredValidators();
      }
      else
      {
        if (!this.isReadOnly)
        {
          this.familyIncome.enable({ emitEvent: false });
          this.setFamilyIncomeRequiredValidators();
        }
      }
      this.familyIncome.updateValueAndValidity({ emitEvent: false });
      this.familyIncomeUnknownDeclined.updateValueAndValidity({ emitEvent: false });
      this.inValueChanges = false;
    }
  }

  private setFamilyIncomeRequiredValidators(): void
  {
    if (this.isRequired('FAMILY_INCOME'))
    {
      if ((this.familyIncome.enabled) && (this.familyIncome.value === null || this.familyIncome.value === ''))
      {
        this.familyIncome.setValidators([Validators.required]);
        this.familyIncomeUnknownDeclined.setValidators([]);
        this.familyIncome.updateValueAndValidity({ emitEvent: false });
        this.familyIncomeUnknownDeclined.updateValueAndValidity({ emitEvent: false });
      }
      else
        if ((this.familyIncomeUnknownDeclined.enabled) && (this.familyIncomeUnknownDeclined.value === null || this.familyIncomeUnknownDeclined.value === ''))
        {
          this.familyIncomeUnknownDeclined.setValidators([Validators.required]);
          this.familyIncome.setValidators([]);
          this.familyIncome.updateValueAndValidity({ emitEvent: false });
          this.familyIncomeUnknownDeclined.updateValueAndValidity({ emitEvent: false });
        }
    }
  }

  private tribalEnrolledChanged(value: boolean): void
  {
    this.tribalEnrollments.setValidators(value && this.isRequired('TRIBAL_ENROLLMENTS') && this.allTribalEnrollments.length > 0 ? [Validators.required] : []);
    this.tribalEnrollments.updateValueAndValidity();
  }

  private tribalAffiliatedChanged(value: boolean): void
  {
    this.tribalAffiliations.setValidators(value && this.isRequired('TRIBAL_AFFILIATIONS') && this.allTribalAffiliations.length > 0 ? [Validators.required] : []);
    this.tribalAffiliations.updateValueAndValidity();
  }

  /**
   * Notificate have changed and handle the cell and email validators.
   *
   * @param notification Current selected notification.
   */
  private notificationChanged(notification: string): void
  {
    if (notification === 'SMS')
    {
      this.cellPhoneMandatory = true;
      this.emailMandatory = this.isRequired('EMAIL');
      this.cellPhone.setValidators([Validators.required]);
      this.email.setValidators(this.emailMandatory ? [Validators.required, Validators.email] : [Validators.email]);
    }
    else if (notification === 'EMAIL')
    {
      this.emailMandatory = true;
      this.cellPhoneMandatory = this.isRequired('CELL_PHONE');
      this.email.setValidators([Validators.required, Validators.email]);
      this.cellPhone.setValidators(this.cellPhoneMandatory ? [Validators.required] : []);
    }
    else
    {
      this.cellPhoneMandatory = this.isRequired('CELL_PHONE');
      this.emailMandatory = this.isRequired('EMAIL');
      this.cellPhone.setValidators(this.cellPhoneMandatory ? [Validators.required] : []);
      this.email.setValidators(this.emailMandatory ? [Validators.required, Validators.email] : [Validators.email]);
    }
    this.email.updateValueAndValidity();
    this.cellPhone.updateValueAndValidity();
  }

  private initIdentifier(id = 0, version = 0, type: any, source: any, identifierValue: string): UntypedFormGroup
  {
    const disableExistingIdentifier = this.isReadOnly || (id > 0 && !this.addEditSubjectIdentifiersEnabled);
    const group: any = {};
    group.id = [id];
    group.type = [{ value: type, disabled: disableExistingIdentifier }, Validators.required];
    group.source = [{ value: source, disabled: disableExistingIdentifier }];
    group.value = [{ value: identifierValue, disabled: disableExistingIdentifier }, Validators.required];
    group.version = version;
    return this.fb.group(group);
  }

  private initOtherName(id = 0, version = 0, nameType: any, givenName: string, familyName: string): UntypedFormGroup
  {
    const group: any = {};
    group.id = [id];
    group.nameType = [{ value: nameType, disabled: this.isReadOnly }, Validators.required];
    group.givenName = [{ value: givenName, disabled: this.isReadOnly }, this.getRequiredValidator('FIRST_NAME_OTHER_NAMES')];
    group.familyName = [{ value: familyName, disabled: this.isReadOnly }, this.getRequiredValidator('LAST_NAME_OTHER_NAMES')];
    group.version = version;
    return this.fb.group(group);
  }

  private initAddress(id = 0, addressType: string, isPrimary: boolean, streetLine: string, streetLineAdditional: string, city: string,
    county: string, state: string, postalCode: string, country: string, latitude: string, longitude: string): UntypedFormGroup
  {
    const group: any = {};
    group.id = [id];
    group.addressType = [{ value: addressType, disabled: this.isReadOnly }, Validators.required];
    group.isPrimary = [{ value: isPrimary, disabled: this.isReadOnly }];
    group.streetLine = [{ value: streetLine, disabled: this.isReadOnly }, this.getRequiredValidator('ADDRESS_LINE1')];
    group.streetLineAdditional = [{ value: streetLineAdditional, disabled: this.isReadOnly }, null];
    group.city = [{ value: city, disabled: this.isReadOnly }, this.getRequiredValidator('CITY')];
    group.county = [{ value: county, disabled: this.isReadOnly }, this.getRequiredValidator('COUNTY')];
    group.state = [{ value: state, disabled: this.isReadOnly }, this.getRequiredValidator('STATE')];
    group.postalCode = [{ value: postalCode, disabled: this.isReadOnly }, this.getRequiredValidator('ZIP_POSTAL_CODE')];
    group.country = [{ value: country, disabled: this.isReadOnly }, this.getRequiredValidator('COUNTRY')];
    group.latitude = latitude;
    group.longitude = longitude;

    return this.fb.group(group);
  }

  private getInsuranceDateValidators(insuranceField: string): any[]
  {
    const insuranceDateValidators: any[] = [];
    const required = this.getRequiredValidatorInsurance(insuranceField);
    if (required)
    {
      insuranceDateValidators.push(required);
    }
    insuranceDateValidators.push((control: UntypedFormControl) =>
      (!control.value || new Date(control.value) <= this.maxInsuranceDate) ? null : { insuranceDateMax: true }
    );
    return insuranceDateValidators;
  }

  private validateInsuranceDateControls(): void
  {
    if (!this.memberForm?.controls?.insurances?.controls) return;
    const insurances = this.memberForm.controls.insurances.controls;
    for (let i = 0; i < insurances.length; i++)
    {
      const group = insurances[i] as UntypedFormGroup;
      group.controls.startDate?.updateValueAndValidity();
      group.controls.endDate?.updateValueAndValidity();
    }
  }

  private initInsurance(id = 0,
    insurer: string, startDate: string, endDate: string,
    insuredGivenName: string, insuredFamilyName: string, businessPhoneNumber: string,
    insuranceMemberId: string, plan: string, groupId: string,
    policyHolder: string, employer: string, insurerUrl: string,
    card: any, cardDocumentName: string, cardDocumentMimeType: string, deleteCard: boolean,
    cardDocumentId: string, cardDocumentDate: string, cardDocumentUrl: string, insuranceExternalId: string,
    deleted: boolean): UntypedFormGroup
  {
    let urlValidatorsRequired = null;
    if (this.isRequiredInsurance('INSURER_WEBSITE'))
    {
      urlValidatorsRequired = [
        Validators.required,
        Validators.pattern(this.urlPattern)
      ];
    }
    else
    {
      urlValidatorsRequired = [Validators.pattern(this.urlPattern)];
    }

    const group: any = {};
    group.id = [id];
    group.insurer = [{ value: insurer, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('INSURER')];
    group.startDate = [{ value: startDate, disabled: this.isReadOnly }, this.getInsuranceDateValidators('START_DATE')];
    group.endDate = [{ value: endDate, disabled: this.isReadOnly }, this.getInsuranceDateValidators('END_DATE')];
    group.insuredGivenName = [{ value: insuredGivenName, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('INSURED_FIRST_NAME')];
    group.insuredFamilyName = [{ value: insuredFamilyName, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('INSURED_LAST_NAME')];
    group.businessPhoneNumber = [{ value: businessPhoneNumber, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('INSURER_PHONE')];
    group.insuranceMemberId = [{ value: insuranceMemberId, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('INSURANCE_MEMBER_ID')];
    group.plan = [{ value: plan, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('PLAN')];
    group.groupId = [{ value: groupId, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('GROUP_ID')];
    group.policyHolder = [{ value: policyHolder, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('POLICY_HOLDER')];
    group.employer = [{ value: employer, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('EMPLOYER')];
    group.insurerUrl = [{ value: insurerUrl, disabled: this.isReadOnly }, urlValidatorsRequired];
    group.card = [{ value: card, disabled: this.isReadOnly }];
    group.cardDocumentName = [{ value: cardDocumentName, disabled: this.isReadOnly }, this.getRequiredValidatorInsurance('INSURANCE_CARD')];
    group.cardDocumentMimeType = [{ value: cardDocumentMimeType, disabled: this.isReadOnly }];
    group.deleteCard = [{ value: deleteCard, disabled: this.isReadOnly }];
    group.cardDocumentId = [{ value: cardDocumentId, disabled: this.isReadOnly }];
    group.cardDocumentDate = [{ value: cardDocumentDate, disabled: this.isReadOnly }];
    group.cardDocumentUrl = [{ value: cardDocumentUrl, disabled: this.isReadOnly }];
    group.insuranceExternalId = [{ value: insuranceExternalId, disabled: this.isReadOnly || !this.isOperatorRole }, this.getRequiredValidatorInsurance('INSURANCE_EXTERNAL_ID')];
    group.deleted = [{ value: deleted, disabled: this.isReadOnly }];

    return this.fb.group(group);
  }

  private initMemberChildren(id = 0, childrenId: string, displayName: string, groupValue: string): UntypedFormGroup
  {
    const group: any = {};
    group.id = [id];
    group.childrenId = [{ value: childrenId }];
    group.value = [{ value: groupValue, disabled: this.isReadOnly }];
    group.displayName = [{ value: displayName }];

    return this.fb.group(group);
  }

  private initMemberAdult(id = 0, adultId: string, displayName: string, groupValue: string): UntypedFormGroup
  {
    const group: any = {};
    group.id = [id];
    group.adultId = [{ value: adultId }];
    group.value = [{ value: groupValue, disabled: this.isReadOnly }];
    group.displayName = [{ value: displayName }];

    return this.fb.group(group);
  }

  private setMemberChildren(objectToPersist: any): void
  {
    objectToPersist.memberChildren.forEach(d =>
    {
      delete d.displayName;
      if (d.childrenId.value !== undefined)
      {
        d.childrenId = d.childrenId.value;
      }
    });
    const cleanMemberChildren = objectToPersist.memberChildren.filter(x => x.value !== null);
    objectToPersist.memberChildren = cleanMemberChildren;
  }

  private setMemberAdults(objectToPersist: any): void
  {
    objectToPersist.memberAdults.forEach(d =>
    {
      delete d.displayName;
      if (d.adultId.value !== undefined)
      {
        d.adultId = d.adultId.value;
      }
    });
    const cleanMemberAdults = objectToPersist.memberAdults.filter(x => x.value !== null);
    objectToPersist.memberAdults = cleanMemberAdults;
  }

  private setMemberWrittenLanguages(objectToPersist: any): void
  {
    if (objectToPersist.memberWrittenLanguages !== null)
    {
      const memberWrittenLanguages = [];
      objectToPersist.memberWrittenLanguages.forEach(d =>
      {
        memberWrittenLanguages.push({
          dictionaryId: d.id
        });
      });
      objectToPersist.memberWrittenLanguages = memberWrittenLanguages;
    }
  }

  private setMemberReadingLanguages(objectToPersist: any): void
  {
    if (objectToPersist.memberReadingLanguages !== null)
    {
      const memberReadingLanguages = [];
      objectToPersist.memberReadingLanguages.forEach(d =>
      {
        memberReadingLanguages.push({
          dictionaryId: d.id
        });
      });
      objectToPersist.memberReadingLanguages = memberReadingLanguages;
    }
  }

  private setMemberOrganizations(objectToPersist: any): void
  {
    if (objectToPersist.memberOrganizations !== null)
    {
      const memberOrganizations = [];
      objectToPersist.memberOrganizations.forEach(d =>
      {
        memberOrganizations.push({ id: d.recordId, organizationId: d.id, version: d.recordVersion });
      });
      objectToPersist.memberOrganizations = memberOrganizations;
    };
  }

  private continueMemberLoad(member: any, disableManager = false): void
  {
    this.clonedMember = cloneDeep(member);

    forkJoin([
      this.dictionaryService.getCachedTotalChildren(),
      this.dictionaryService.getCachedTotalAdults()
    ])
      .subscribe((responseList: any) =>
      {
        // Get Total Children and Adults
        this.totalChildrenCodeSet = sortBy(responseList[0], ['displayName']);
        this.totalAdultsCodeSet = sortBy(responseList[1], ['displayName']);

        if (this.channelId !== undefined)
        {
          // get the list of users of the channel staff group
          this.userService.getUsersByChannelGroups(this.channelId).subscribe({
            next: (users) =>
            {
              this.caseManagers = users;
              this.channelService.getChannel(this.channelId).subscribe(
                {
                  next: (channelData) =>
                  {
                    this.selectedChannel = channelData;
                    this.buildForm(disableManager);
                  }
                }
              );
            }
          });
        }
        else
        {
          this.buildForm(disableManager);
        }
      });
  }

  private calculateTotalChildren(): void
  {
    let total = 0;
    for (let i = 0; i < this.memberForm.controls.memberChildren.controls.length; i++)
    {
      total += this.memberForm.controls.memberChildren.controls[i].get('value').value ?
        this.memberForm.controls.memberChildren.controls[i].get('value').value : 0;
    }
    this.totalChildren = total;
  }

  private calculateTotalAdults(): void
  {
    let total = 0;
    for (let i = 0; i < this.memberForm.controls.memberAdults.controls.length; i++)
    {
      total += this.memberForm.controls.memberAdults.controls[i].get('value').value ?
        this.memberForm.controls.memberAdults.controls[i].get('value').value : 0;
    }
    this.totalAdults = total;
  }

  private displayPreferredContactError(methodValue: string): void
  {
    this.messageHandlerService.displayDirectMessage('error',
      this.translate.instant('PREFERRED-CONTACT-METHOD-ERROR').replace('{{method}}',
        this.contactMethods.find(x => x.value === methodValue).text));
  }

  private getMemberCountTabs(): void
  {
    this.memberService.getMemberCountTabs(this.member.id).subscribe({
      next: (data) =>
      {
        this.tabCounts = data;
      },
      error: (errorResponse: any) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  private setViewExtensionsColumnsVisibility(): void
  {
    this.viewExtensionsShowDisplayName = this.viewExtensions.data.filter(x => x.displayName).length > 0;
    this.viewExtensionsShowAlternateValue = this.viewExtensions.data.filter(x => x.alternateValue).length > 0;
  }

  private refreshExtensionDisplayNames(value: string): void
  {
    this.extensionService.refreshExtensionDisplayNames(value, this.patExtensionFormGroup, this.viewExtensions);
  }

}
